import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-030c21b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AdminTournaments" }
const _hoisted_2 = { id: "showtournaments" }
const _hoisted_3 = { class: "display-2 adminHeadline" }
const _hoisted_4 = { class: "tabHeight" }
const _hoisted_5 = { class: "row align--center justify--start" }
const _hoisted_6 = { class: "md1 flex ml-4" }
const _hoisted_7 = {
  class: "md3 flex",
  style: {"display":"flex"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_9 = { class: "md2 flex" }
const _hoisted_10 = { class: "flex md2" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Opret ny kategori")
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_14 = {
  class: "va-table va-table--striped tournamentcategoriestable",
  style: {"width":"100%"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { hidden: "" }, "Id", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Handlinger", -1))
const _hoisted_17 = ["id"]
const _hoisted_18 = ["id"]
const _hoisted_19 = ["id"]
const _hoisted_20 = ["id"]
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_22 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_24 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_25 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_27 = { class: "selectPageSize" }
const _hoisted_28 = { class: "display-6 center mb-2" }
const _hoisted_29 = { class: "layout gutter--xl" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "flex md8 tournamentCategoryModal" }
const _hoisted_32 = { class: "flex md4 tournamentCategoryModal" }
const _hoisted_33 = { class: "row justify--center" }
const _hoisted_34 = { class: "flex" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_36 = { class: "tabHeight" }
const _hoisted_37 = { class: "row align--center justify--start" }
const _hoisted_38 = { class: "md1 flex ml-2" }
const _hoisted_39 = {
  class: "md4 flex",
  style: {"display":"flex"}
}
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_41 = { class: "md2 flex" }
const _hoisted_42 = { class: "row align--center mt-2" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md1 ml-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Kolonner:")
], -1))
const _hoisted_44 = {
  class: "flex md10",
  style: {"display":"flex"}
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_47 = {
  class: "va-table va-table--striped tournamentrowstable",
  style: {"width":"100%"}
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { hidden: "" }, "Id", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Handlinger", -1))
const _hoisted_50 = ["id"]
const _hoisted_51 = ["id"]
const _hoisted_52 = ["id"]
const _hoisted_53 = ["id"]
const _hoisted_54 = ["id"]
const _hoisted_55 = ["id"]
const _hoisted_56 = ["id"]
const _hoisted_57 = ["id"]
const _hoisted_58 = ["id"]
const _hoisted_59 = ["id"]
const _hoisted_60 = ["id"]
const _hoisted_61 = ["id"]
const _hoisted_62 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_63 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_65 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_66 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_68 = { class: "selectPageSize" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "center display-6 mb-2" }, "Ændre turneringsrække-oplysninger", -1))
const _hoisted_70 = { class: "layout gutter--xl" }
const _hoisted_71 = { class: "row justify--center" }
const _hoisted_72 = { class: "flex md8 tournamentRowModal" }
const _hoisted_73 = { class: "row justify--center" }
const _hoisted_74 = { class: "flex md3 tournamentRowModal" }
const _hoisted_75 = { class: "flex md3 tournamentRowModal" }
const _hoisted_76 = { class: "flex md3 tournamentRowModal" }
const _hoisted_77 = { class: "flex md3 tournamentRowModal" }
const _hoisted_78 = { class: "flex md3 tournamentRowModal" }
const _hoisted_79 = { class: "flex md3 tournamentRowModal" }
const _hoisted_80 = { class: "row justify--center" }
const _hoisted_81 = { class: "flex" }
const _hoisted_82 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_83 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_84 = { class: "tabHeight" }
const _hoisted_85 = { class: "row align--center justify--space-around" }
const _hoisted_86 = { class: "md1 flex" }
const _hoisted_87 = { class: "flex md3" }
const _hoisted_88 = { class: "flex md3" }
const _hoisted_89 = /*#__PURE__*/_createTextVNode("Opret ny regel")
const _hoisted_90 = { key: 0 }
const _hoisted_91 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_92 = {
  class: "va-table va-table--striped rulesTable",
  style: {"width":"100%"}
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Region", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Handlinger", -1))
const _hoisted_95 = /*#__PURE__*/_createTextVNode("Rediger")
const _hoisted_96 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout gutter--xl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "emphasizedText" }, "Er du sikker på at du vil slette denne regel?"),
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createElementVNode("b", null, "Handlingen kan ikke fortrydes.")
      ])
    ])
  ])
], -1))
const _hoisted_98 = { class: "row justify--center" }
const _hoisted_99 = { class: "flex" }
const _hoisted_100 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_101 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_102 = { class: "center display-6 mb-2" }
const _hoisted_103 = { class: "layout gutter--xl" }
const _hoisted_104 = { class: "row" }
const _hoisted_105 = { class: "flex md6" }
const _hoisted_106 = { class: "flex md6" }
const _hoisted_107 = { class: "flex md6" }
const _hoisted_108 = { class: "flex md6" }
const _hoisted_109 = { class: "row justify--center" }
const _hoisted_110 = { class: "flex" }
const _hoisted_111 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "center dispaly-6" }, "Regel konfligt advarsel", -1))
const _hoisted_113 = { class: "layout gutter--md" }
const _hoisted_114 = { class: "row" }
const _hoisted_115 = { class: "flex" }
const _hoisted_116 = { class: "center" }
const _hoisted_117 = { class: "center" }
const _hoisted_118 = { class: "row justify--center" }
const _hoisted_119 = { class: "flex" }
const _hoisted_120 = /*#__PURE__*/_createTextVNode("Ok")
const _hoisted_121 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_122 = { class: "tabHeight" }
const _hoisted_123 = { class: "row align--center justify--start" }
const _hoisted_124 = { id: "newtournamentmatchrounds" }
const _hoisted_125 = { key: 0 }
const _hoisted_126 = {
  key: 1,
  class: "form"
}
const _hoisted_127 = { key: 0 }
const _hoisted_128 = { class: "tournamentroundsform-group" }
const _hoisted_129 = { class: "layout gutter--xl" }
const _hoisted_130 = { class: "row" }
const _hoisted_131 = { class: "flex md6" }
const _hoisted_132 = { class: "flex md6" }
const _hoisted_133 = { class: "row" }
const _hoisted_134 = { class: "flex md6" }
const _hoisted_135 = /*#__PURE__*/_createTextVNode("Tilføj runde")
const _hoisted_136 = { class: "flex md6" }
const _hoisted_137 = { class: "row justify--center" }
const _hoisted_138 = { class: "flex" }
const _hoisted_139 = /*#__PURE__*/_createTextVNode("Opret runde")
const _hoisted_140 = { key: 1 }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Turneringsrunderne blev oprettet.", -1))
const _hoisted_142 = /*#__PURE__*/_createTextVNode("Fortsæt")
const _hoisted_143 = { class: "edittournamentRoundToBeCreatedModal" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md12 flex" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "mb-4",
    style: {"font-size":"1.2em"}
  }, "Ændre indstillingerne for runden")
], -1))
const _hoisted_145 = { class: "row justify--space-around" }
const _hoisted_146 = { class: "md6 flex edittournamentRoundToBeCreatedModal" }
const _hoisted_147 = { class: "md6 d-flex edittournamentRoundToBeCreatedModal" }
const _hoisted_148 = { class: "row justify--space-around" }
const _hoisted_149 = { class: "md6 flex edittournamentRoundToBeCreatedModal" }
const _hoisted_150 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_151 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_152 = { class: "tabHeight" }
const _hoisted_153 = { class: "row align--center justify--start" }
const _hoisted_154 = { class: "md1 flex ml-2" }
const _hoisted_155 = {
  class: "md3 flex",
  style: {"display":"flex"}
}
const _hoisted_156 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_157 = { class: "md2 flex" }
const _hoisted_158 = { class: "md5 flex" }
const _hoisted_159 = /*#__PURE__*/_createTextVNode(" Opret sæson ")
const _hoisted_160 = {
  class: "row justify-start va-spacing-y-1",
  style: {"margin":"4px 4px"}
}
const _hoisted_161 = /*#__PURE__*/_createTextVNode(" Start ny sæson")
const _hoisted_162 = { class: "row justify-start va-spacing-y-1" }
const _hoisted_163 = /*#__PURE__*/_createTextVNode(" Opbyg sæsonkampplan")
const _hoisted_164 = /*#__PURE__*/_createTextVNode("Afslut sæson")
const _hoisted_165 = /*#__PURE__*/_createTextVNode("Opret ny kamp")
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center mb-2" }, "Afslut en sæson", -1))
const _hoisted_167 = { class: "layout gutter--xl" }
const _hoisted_168 = { class: "row justify--space-around" }
const _hoisted_169 = { class: "md6 flex editfinalizeTournamentSeasonModal" }
const _hoisted_170 = { class: "md6 flex editfinalizeTournamentSeasonModal" }
const _hoisted_171 = { class: "gutter--xl" }
const _hoisted_172 = { class: "row justify--center align--center" }
const _hoisted_173 = /*#__PURE__*/_createTextVNode("Start")
const _hoisted_174 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center mb-2" }, "Start en ny sæson", -1))
const _hoisted_176 = { class: "layout gutter--xl" }
const _hoisted_177 = { class: "row justify--space-around" }
const _hoisted_178 = { class: "md6 flex flex-col editcreateNewTournamentSeasonModal" }
const _hoisted_179 = { class: "md6 flex flex-col editcreateNewTournamentSeasonModal" }
const _hoisted_180 = { class: "row justify-end" }
const _hoisted_181 = { class: "md6 flex flex-col editcreateNewTournamentSeasonModal" }
const _hoisted_182 = { class: "md6 flex flex-col editcreateNewTournamentSeasonModal" }
const _hoisted_183 = { class: "gutter--xl" }
const _hoisted_184 = { class: "row justify--center align--center" }
const _hoisted_185 = /*#__PURE__*/_createTextVNode("Start")
const _hoisted_186 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center mb-2" }, "Placering og division for holdene i ny sæson", -1))
const _hoisted_188 = { class: "layout gutter--xl" }
const _hoisted_189 = { class: "gutter--xl" }
const _hoisted_190 = { class: "row justify--center align--center" }
const _hoisted_191 = /*#__PURE__*/_createTextVNode("Ok")
const _hoisted_192 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_193 = { class: "display-6 center mb-2" }
const _hoisted_194 = { class: "layout gutter--xl" }
const _hoisted_195 = { class: "row justify--space-around" }
const _hoisted_196 = { class: "md6 flex editcreateNewTournamentSeasonModal" }
const _hoisted_197 = { class: "md6 flex editcreateNewTournamentSeasonModal" }
const _hoisted_198 = { class: "gutter--xl" }
const _hoisted_199 = { class: "row justify--center align--center" }
const _hoisted_200 = /*#__PURE__*/_createTextVNode("Ok")
const _hoisted_201 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center mb-2" }, "Opret ny sæson", -1))
const _hoisted_203 = { class: "layout gutter--xl" }
const _hoisted_204 = {
  class: "row justify--center",
  style: {"padding-right":"5rem","padding-left":"5rem"}
}
const _hoisted_205 = { class: "flex md8 editcreateTournamentSeasonModal" }
const _hoisted_206 = { class: "flex md4 editcreateTournamentSeasonModal" }
const _hoisted_207 = { class: "flex md4 editcreateTournamentSeasonModal" }
const _hoisted_208 = { class: "flex md4 editcreateTournamentSeasonModal" }
const _hoisted_209 = { class: "row justify--center" }
const _hoisted_210 = { class: "flex" }
const _hoisted_211 = /*#__PURE__*/_createTextVNode("Opret sæson")
const _hoisted_212 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_213 = { class: "editcreateTournamentSeasonMatchPlanModal" }
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md12 flex" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "mb-4",
    style: {"font-size":"1.2em"}
  }, "Opbyg turneringssæsonplan")
], -1))
const _hoisted_215 = { class: "row justify--space-around" }
const _hoisted_216 = { class: "md6 flex editcreateTournamentSeasonMatchPlanModal" }
const _hoisted_217 = { class: "md6 flex editcreateTournamentSeasonMatchPlanModal" }
const _hoisted_218 = { class: "row justify--space-around" }
const _hoisted_219 = { class: "md6 flex editcreateTournamentSeasonMatchPlanModal" }
const _hoisted_220 = { class: "md6 flex editcreateTournamentSeasonMatchPlanModal" }
const _hoisted_221 = { class: "row justify--space-around" }
const _hoisted_222 = { class: "md6 flex editcreateTournamentSeasonMatchPlanModal" }
const _hoisted_223 = { class: "row justify--space-around" }
const _hoisted_224 = { class: "md6 flex editcreateTournamentSeasonMatchPlanModal" }
const _hoisted_225 = { class: "flex md12" }
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Tærskel for automatisk forøgelse af antal gange de enkelte hold skal mødes i kamp. Hvis antallet af hold er lig med eller lavere end den værdi, der er fastsat her, forøges antallet af kamptræf med en.", -1))
const _hoisted_227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_229 = { class: "flex md8" }
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Hvis der vælges en slot-indstilling forskelligt fra automatisk, så vil der i starten under gemningsprocessen ske en sletning af allerede eksisterende kampplanoplysninger, der måtte være i den valgte slot.", -1))
const _hoisted_231 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_232 = /*#__PURE__*/_createTextVNode("Opbyg plan")
const _hoisted_233 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md12 flex" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "mb-4",
    style: {"font-size":"1.2em"}
  }, "Turneringskampplanen")
], -1))
const _hoisted_235 = { class: "createTournamentSeasonMatchPlanEditModal" }
const _hoisted_236 = { class: "justify--center" }
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_238 = { class: "text--center" }
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_240 = { class: "justify--center" }
const _hoisted_241 = { class: "row justify--space-around" }
const _hoisted_242 = {
  key: 0,
  class: "md4 flex createTournamentSeasonMatchPlanEditModal"
}
const _hoisted_243 = {
  key: 1,
  class: "md4 flex createTournamentSeasonMatchPlanEditModal"
}
const _hoisted_244 = {
  key: 2,
  class: "md4 flex createTournamentSeasonMatchPlanEditModal"
}
const _hoisted_245 = {
  key: 3,
  class: "md4 flex createTournamentSeasonMatchPlanEditModal"
}
const _hoisted_246 = {
  key: 4,
  class: "md4 flex createTournamentSeasonMatchPlanEditModal"
}
const _hoisted_247 = {
  key: 5,
  class: "md4 flex createTournamentSeasonMatchPlanEditModal"
}
const _hoisted_248 = { class: "gutter--xl" }
const _hoisted_249 = { class: "row justify--center align--center" }
const _hoisted_250 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_251 = { class: "row align--center mt-2" }
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md1 ml-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Kolonner:")
], -1))
const _hoisted_253 = {
  class: "flex md10",
  style: {"display":"flex"}
}
const _hoisted_254 = { key: 0 }
const _hoisted_255 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_256 = {
  class: "va-table--striped va-table tournamentmatchschedulestable",
  style: {"width":"100%"}
}
const _hoisted_257 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { hidden: "" }, "Id", -1))
const _hoisted_258 = { class: "center" }
const _hoisted_259 = { class: "center" }
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Handlinger", -1))
const _hoisted_261 = ["id"]
const _hoisted_262 = ["id"]
const _hoisted_263 = ["id"]
const _hoisted_264 = ["id"]
const _hoisted_265 = ["id"]
const _hoisted_266 = ["id"]
const _hoisted_267 = ["id"]
const _hoisted_268 = ["id"]
const _hoisted_269 = ["id"]
const _hoisted_270 = ["id"]
const _hoisted_271 = ["id"]
const _hoisted_272 = /*#__PURE__*/_createTextVNode("Kampseddlen")
const _hoisted_273 = ["id"]
const _hoisted_274 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_275 = /*#__PURE__*/_createTextVNode("Spillere")
const _hoisted_276 = /*#__PURE__*/_createTextVNode("Kampseddel")
const _hoisted_277 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_278 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_279 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_280 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_281 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_282 = { class: "selectPageSize" }
const _hoisted_283 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center mb-2" }, "Opret ny turneringskamp", -1))
const _hoisted_284 = { class: "layout gutter--xl" }
const _hoisted_285 = { class: "row justify--center" }
const _hoisted_286 = { class: "flex md5" }
const _hoisted_287 = { class: "flex md5" }
const _hoisted_288 = { class: "row justify--center" }
const _hoisted_289 = { class: "flex md5" }
const _hoisted_290 = { class: "flex md5" }
const _hoisted_291 = { class: "row justify--center" }
const _hoisted_292 = { class: "flex md5" }
const _hoisted_293 = { class: "flex md5" }
const _hoisted_294 = { class: "row justify--center" }
const _hoisted_295 = { class: "flex" }
const _hoisted_296 = /*#__PURE__*/_createTextVNode("Opret kamp")
const _hoisted_297 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_298 = { class: "display-6 center" }
const _hoisted_299 = { class: "layout gutter--xl" }
const _hoisted_300 = { class: "row justify--center align--center" }
const _hoisted_301 = { class: "flex md5 tournamentMatchScheduleModal" }
const _hoisted_302 = { class: "flex md5 tournamentMatchScheduleModal" }
const _hoisted_303 = { class: "flex md5 tournamentMatchScheduleModal" }
const _hoisted_304 = { class: "flex md5 tournamentMatchScheduleModal" }
const _hoisted_305 = { class: "flex md5 tournamentMatchScheduleModal" }
const _hoisted_306 = { class: "flex md5 tournamentMatchScheduleModal" }
const _hoisted_307 = { class: "flex md5 tournamentMatchScheduleModal" }
const _hoisted_308 = { class: "row justify--center" }
const _hoisted_309 = { class: "flex" }
const _hoisted_310 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_311 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_312 = { class: "editTournamentMatchSettlementModal" }
const _hoisted_313 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md12 flex" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "mb-4",
    style: {"font-size":"1.2em"}
  }, "Kampseddel")
], -1))
const _hoisted_314 = { class: "row justify--center" }
const _hoisted_315 = { class: "md6 flex" }
const _hoisted_316 = { class: "va-table-responsive" }
const _hoisted_317 = {
  class: "va-table tournamentmatchsettlementtopinfotable",
  style: {"width":"100%"}
}
const _hoisted_318 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_319 = { id: "tournamentmatchsettlementtopinfotable-row1" }
const _hoisted_320 = { id: "tournamentmatchsettlementtopinfotable-row1" }
const _hoisted_321 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { id: "tournamentmatchsettlementtopinfotable-row1" }, null, -1))
const _hoisted_322 = { id: "tournamentmatchsettlementtopinfotable-row1" }
const _hoisted_323 = { id: "tournamentmatchsettlementtopinfotable-row1" }
const _hoisted_324 = { id: "tournamentmatchsettlementtopinfotable-row1" }
const _hoisted_325 = { id: "tournamentmatchsettlementtopinfotable-row1" }
const _hoisted_326 = { id: "tournamentmatchsettlementtopinfotable-row1" }
const _hoisted_327 = { id: "tournamentmatchsettlementtopinfotable-row1" }
const _hoisted_328 = { id: "tournamentmatchsettlementtopinfotable-row1" }
const _hoisted_329 = { id: "tournamentmatchsettlementtopinfotable-row1" }
const _hoisted_330 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { id: "tournamentmatchsettlementtopinfotable-row1" }, null, -1))
const _hoisted_331 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_332 = { class: "row" }
const _hoisted_333 = { class: "flex md3" }
const _hoisted_334 = { class: "flex md3" }
const _hoisted_335 = { class: "va-table-responsive" }
const _hoisted_336 = {
  class: "va-table tournamentmatchsettlementplayerinfotable",
  style: {"width":"100%"}
}
const _hoisted_337 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Spillernavn"),
    /*#__PURE__*/_createElementVNode("th", null, "Dom"),
    /*#__PURE__*/_createElementVNode("th", null, "Licens"),
    /*#__PURE__*/_createElementVNode("th", null, "Vundne kampe"),
    /*#__PURE__*/_createElementVNode("th", null, "Vundne sæt"),
    /*#__PURE__*/_createElementVNode("th", null, "Tabte sæt"),
    /*#__PURE__*/_createElementVNode("th", null, "180"),
    /*#__PURE__*/_createElementVNode("th", null, "Højeste lukker"),
    /*#__PURE__*/_createElementVNode("th", null, "Hurtigste sæt")
  ])
], -1))
const _hoisted_338 = ["id"]
const _hoisted_339 = ["id"]
const _hoisted_340 = ["id"]
const _hoisted_341 = ["id"]
const _hoisted_342 = ["id"]
const _hoisted_343 = ["id"]
const _hoisted_344 = ["id"]
const _hoisted_345 = ["id"]
const _hoisted_346 = ["id"]
const _hoisted_347 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_348 = { class: "row" }
const _hoisted_349 = { class: "flex md3" }
const _hoisted_350 = { class: "flex md3" }
const _hoisted_351 = { class: "va-table-responsive" }
const _hoisted_352 = {
  class: "va-table tournamentmatchsettlementplayerinfotable",
  style: {"width":"100%"}
}
const _hoisted_353 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Spillernavn"),
    /*#__PURE__*/_createElementVNode("th", null, "Dom"),
    /*#__PURE__*/_createElementVNode("th", null, "Licens"),
    /*#__PURE__*/_createElementVNode("th", null, "Vundne kampe"),
    /*#__PURE__*/_createElementVNode("th", null, "Vundne sæt"),
    /*#__PURE__*/_createElementVNode("th", null, "Tabte sæt"),
    /*#__PURE__*/_createElementVNode("th", null, "180"),
    /*#__PURE__*/_createElementVNode("th", null, "Højeste lukker"),
    /*#__PURE__*/_createElementVNode("th", null, "Hurtigste sæt")
  ])
], -1))
const _hoisted_354 = ["id"]
const _hoisted_355 = ["id"]
const _hoisted_356 = ["id"]
const _hoisted_357 = ["id"]
const _hoisted_358 = ["id"]
const _hoisted_359 = ["id"]
const _hoisted_360 = ["id"]
const _hoisted_361 = ["id"]
const _hoisted_362 = ["id"]
const _hoisted_363 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_364 = {
  key: 0,
  class: "va-table-responsive"
}
const _hoisted_365 = {
  class: "va-table tournamentmatchsettlementrowstable",
  style: {"width":"100%"}
}
const _hoisted_366 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Kamp"),
    /*#__PURE__*/_createElementVNode("th", null, "Navn"),
    /*#__PURE__*/_createElementVNode("th", null, "Resultater"),
    /*#__PURE__*/_createElementVNode("th", null, "Resultater"),
    /*#__PURE__*/_createElementVNode("th", null, "Navn")
  ])
], -1))
const _hoisted_367 = ["id"]
const _hoisted_368 = ["id"]
const _hoisted_369 = ["id"]
const _hoisted_370 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_371 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_372 = ["id"]
const _hoisted_373 = ["id"]
const _hoisted_374 = { class: "va-table-responsive" }
const _hoisted_375 = {
  class: "va-table tournamentrowstable",
  style: {"width":"100%","--va-form-element-default-width":"96px"}
}
const _hoisted_376 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Rest"),
    /*#__PURE__*/_createElementVNode("th", null, "Dart"),
    /*#__PURE__*/_createElementVNode("th", null, "Lukket")
  ])
], -1))
const _hoisted_377 = ["id"]
const _hoisted_378 = ["id"]
const _hoisted_379 = ["id"]
const _hoisted_380 = ["id"]
const _hoisted_381 = ["id"]
const _hoisted_382 = { class: "va-table-responsive" }
const _hoisted_383 = {
  class: "va-table tournamentrowstable",
  style: {"width":"100%","--va-form-element-default-width":"96px"}
}
const _hoisted_384 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Lukket"),
    /*#__PURE__*/_createElementVNode("th", null, "Dart"),
    /*#__PURE__*/_createElementVNode("th", null, "Rest")
  ])
], -1))
const _hoisted_385 = ["id"]
const _hoisted_386 = ["id"]
const _hoisted_387 = ["id"]
const _hoisted_388 = ["id"]
const _hoisted_389 = ["id"]
const _hoisted_390 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_391 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_392 = /*#__PURE__*/_createTextVNode("Opdater")
const _hoisted_393 = /*#__PURE__*/_createTextVNode("Protest!")
const _hoisted_394 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_395 = { class: "edittournamentMatchSettlementTeamProtestStatusModal" }
const _hoisted_396 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md12 flex" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "mb-4",
    style: {"font-size":"1.2em"}
  }, "Indstil status af hold-protest for denne kamp")
], -1))
const _hoisted_397 = { class: "row justify--space-around" }
const _hoisted_398 = { class: "md6 flex edittournamentMatchSettlementTeamProtestStatusModal" }
const _hoisted_399 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_400 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_401 = { class: "display-6 center" }
const _hoisted_402 = { key: 0 }
const _hoisted_403 = { class: "layout gutter--xl" }
const _hoisted_404 = { class: "row justify--center" }
const _hoisted_405 = { class: "flex md6" }
const _hoisted_406 = { class: "flex md6" }
const _hoisted_407 = { class: "row justify--center" }
const _hoisted_408 = { class: "flex md6" }
const _hoisted_409 = /*#__PURE__*/_createTextVNode(" Rækkefølge ")
const _hoisted_410 = { class: "flex md6" }
const _hoisted_411 = /*#__PURE__*/_createTextVNode(" Rækkefølge ")
const _hoisted_412 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_413 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_414 = { class: "tabHeight" }
const _hoisted_415 = { class: "row align--center" }
const _hoisted_416 = { class: "flex md1 ml-4" }
const _hoisted_417 = { class: "flex md2" }
const _hoisted_418 = { class: "flex md2" }
const _hoisted_419 = { class: "flex md2" }
const _hoisted_420 = { class: "flex md2" }
const _hoisted_421 = { class: "flex md2" }
const _hoisted_422 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, "Exportering...", -1))
const _hoisted_423 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Exporter", -1))
const _hoisted_424 = { class: "va-table-responsive" }
const _hoisted_425 = {
  class: "va-table va-table--striped",
  style: {"width":"100%"}
}
const _hoisted_426 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Status", -1))
const _hoisted_427 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Turneringskategori", -1))
const _hoisted_428 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Handling", -1))
const _hoisted_429 = ["textContent"]
const _hoisted_430 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_431 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_432 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_433 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_434 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_435 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_436 = { class: "selectPageSize" }
const _hoisted_437 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Er du sikker på at du vil trække holdet fra turnerninger?"),
    /*#__PURE__*/_createElementVNode("p", null, "Alle holdets resterende kampe vil blive taberdømt."),
    /*#__PURE__*/_createElementVNode("p", null, "Denne handlingn kan ikke fotrydes.")
  ])
], -1))
const _hoisted_438 = { class: "row justify--center" }
const _hoisted_439 = { class: "flex" }
const _hoisted_440 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_441 = /*#__PURE__*/_createTextVNode("Træk holdet")
const _hoisted_442 = { class: "center display-6" }
const _hoisted_443 = { class: "layout gutter--xl" }
const _hoisted_444 = { class: "row justify--center align--center" }
const _hoisted_445 = { class: "flex md6" }
const _hoisted_446 = { class: "teamInfoBox" }
const _hoisted_447 = { class: "flex md6" }
const _hoisted_448 = { class: "teamInfoBox" }
const _hoisted_449 = { class: "flex md4" }
const _hoisted_450 = { class: "teamInfoBox" }
const _hoisted_451 = { class: "flex md4" }
const _hoisted_452 = { class: "teamInfoBox" }
const _hoisted_453 = { class: "flex md4" }
const _hoisted_454 = { class: "teamInfoBox" }
const _hoisted_455 = { class: "flex md4 center" }
const _hoisted_456 = /*#__PURE__*/_createTextVNode("Træk holdet")
const _hoisted_457 = { class: "va-table-responsive" }
const _hoisted_458 = {
  class: "va-table va-table--striped",
  style: {"width":"100%"}
}
const _hoisted_459 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Kampnr."),
    /*#__PURE__*/_createElementVNode("th", null, "Kampdato"),
    /*#__PURE__*/_createElementVNode("th", null, "Hjemmehold"),
    /*#__PURE__*/_createElementVNode("th", null, "Udehold"),
    /*#__PURE__*/_createElementVNode("th", null, "Resultat"),
    /*#__PURE__*/_createElementVNode("th", null, "Færdig spillet")
  ])
], -1))
const _hoisted_460 = { key: 0 }
const _hoisted_461 = { key: 1 }
const _hoisted_462 = { class: "strikeThrough" }
const _hoisted_463 = {
  key: 2,
  class: "center"
}
const _hoisted_464 = { class: "row justify--center" }
const _hoisted_465 = { class: "flex" }
const _hoisted_466 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_467 = { class: "tabHeight" }
const _hoisted_468 = { class: "row align--center justify--start" }
const _hoisted_469 = { class: "md2 flex" }
const _hoisted_470 = { class: "md2 flex" }
const _hoisted_471 = { class: "md2 flex" }
const _hoisted_472 = /*#__PURE__*/_createTextVNode(" Sort ")
const _hoisted_473 = { key: 0 }
const _hoisted_474 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_475 = {
  class: "va-table--striped va-table",
  style: {"width":"100%"}
}
const _hoisted_476 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Kamp nr."),
    /*#__PURE__*/_createElementVNode("th", null, "playerName"),
    /*#__PURE__*/_createElementVNode("th", null, "info"),
    /*#__PURE__*/_createElementVNode("th", null, "hold_holdnavn"),
    /*#__PURE__*/_createElementVNode("th", null, "created_at"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_477 = ["onClick"]
const _hoisted_478 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_479 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_480 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_481 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_482 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Player per side:", -1))
const _hoisted_483 = { class: "selectPageSize" }
const _hoisted_484 = {
  class: "center display-6",
  style: {"color":"rgb(44, 130, 224)"}
}
const _hoisted_485 = { class: "center display-6" }
const _hoisted_486 = { class: "center display-6" }
const _hoisted_487 = { class: "layout gutter--xl" }
const _hoisted_488 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", {
  class: "display-6",
  style: {"color":"rgb(44, 130, 224)"}
}, "Last Played Match", -1))
const _hoisted_489 = {
  key: 0,
  class: "modal-container"
}
const _hoisted_490 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-item" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "KAMP NR.")
], -1))
const _hoisted_491 = { class: "modal-item" }
const _hoisted_492 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-item" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "DATE & TIME")
], -1))
const _hoisted_493 = { class: "modal-item" }
const _hoisted_494 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-item" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "REAKKE")
], -1))
const _hoisted_495 = { class: "modal-item" }
const _hoisted_496 = { key: 1 }
const _hoisted_497 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "center modal-item" }, "Not found a last played match for this Team", -1))
const _hoisted_498 = [
  _hoisted_497
]
const _hoisted_499 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", {
  class: "display-6",
  style: {"color":"rgb(44, 130, 224)"}
}, "Next Planned Match", -1))
const _hoisted_500 = {
  key: 2,
  class: "modal-container"
}
const _hoisted_501 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-item" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "KAMP NR.")
], -1))
const _hoisted_502 = { class: "modal-item" }
const _hoisted_503 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-item" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "DATE & TIME")
], -1))
const _hoisted_504 = { class: "modal-item" }
const _hoisted_505 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-item" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "REAKKE")
], -1))
const _hoisted_506 = { class: "modal-item" }
const _hoisted_507 = { key: 3 }
const _hoisted_508 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "center modal-item" }, "Not found a next planned match for this Team", -1))
const _hoisted_509 = [
  _hoisted_508
]
const _hoisted_510 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", {
  class: "display-6",
  style: {"color":"rgb(44, 130, 224)"}
}, "Comment", -1))
const _hoisted_511 = { key: 4 }
const _hoisted_512 = { class: "modal-item" }
const _hoisted_513 = { class: "comment-block" }
const _hoisted_514 = /*#__PURE__*/_createTextVNode(" Add ")
const _hoisted_515 = { class: "layout gutter--xl" }
const _hoisted_516 = { class: "row justify--center" }
const _hoisted_517 = { class: "flex" }
const _hoisted_518 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_519 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"font-size":"20px"} }, "Update the Satatus", -1))
const _hoisted_520 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"20px","font-size":"18px"} }, "Are you sure you want to update the status?", -1))
const _hoisted_521 = /*#__PURE__*/_createTextVNode("Yes")
const _hoisted_522 = /*#__PURE__*/_createTextVNode("Annuller")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_tab = _resolveComponent("va-tab")!
  const _component_va_tabs = _resolveComponent("va-tabs")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_form = _resolveComponent("va-form")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_date_picker = _resolveComponent("va-date-picker")!
  const _component_va_time_input = _resolveComponent("va-time-input")!
  const _component_va_button_dropdown = _resolveComponent("va-button-dropdown")!
  const _component_va_progress_circle = _resolveComponent("va-progress-circle")!
  const _component_va_list_item_label = _resolveComponent("va-list-item-label")!
  const _component_va_list_item_section = _resolveComponent("va-list-item-section")!
  const _component_va_list_item = _resolveComponent("va-list-item")!
  const _component_va_list = _resolveComponent("va-list")!
  const _component_va_scroll_container = _resolveComponent("va-scroll-container")!
  const _component_va_collapse = _resolveComponent("va-collapse")!
  const _component_va_pagination = _resolveComponent("va-pagination")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_va_option_list = _resolveComponent("va-option-list")!
  const _component_va_switch = _resolveComponent("va-switch")!
  const _component_va_rating = _resolveComponent("va-rating")!
  const _component_va_list_label = _resolveComponent("va-list-label")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_VaInnerLoading = _resolveComponent("VaInnerLoading")!
  const _component_it_modal = _resolveComponent("it-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.msg), 1),
      _createVNode(_component_va_tabs, {
        class: "adminTabs",
        modelValue: _ctx.tabValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabValue) = $event))
      }, {
        tabs: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Vis og rediger turneringskategorier', 'Vis og rediger turneringsrækker', 'Vis og rediger turneringsregler', 'Opret turneringsrunder', 'Turneringsplan', 'Hold oversigt', 'Player History'], (title) => {
            return _createVNode(_component_va_tab, {
              key: title,
              name: title
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(title), 1)
              ]),
              _: 2
            }, 1032, ["name"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Nulstil kolonner"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.categoryColumSort('reset')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.tournamentCategorySearchInputValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tournamentCategorySearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.findTournamentCategory()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "person_search" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              class: "btn ml-2",
              rounded: false,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.findTournamentCategory()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_va_select, {
              class: "ml-4",
              modelValue: _ctx.filterStatusStringValue,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterStatusStringValue) = $event)),
              options: _ctx.filterStatusStringOptions,
              bordered: "",
              style: {"width":"75%"},
              label: "Kategori status"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_va_button, {
              color: "success",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.newTournamentCategory()))
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("table", _hoisted_14, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_15,
                    _createElementVNode("th", {
                      class: "clickAble",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.categoryColumSort('category')))
                    }, "Navn"),
                    _createElementVNode("th", {
                      class: "center clickAble",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.categoryColumSort('price')))
                    }, "Pris"),
                    _hoisted_16
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.turneringskategoris, (turneringskategori, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: turneringskategori.id
                  }, [
                    _createElementVNode("td", {
                      id: 'tournamentcategoriestable-row' + (index+1),
                      hidden: ""
                    }, _toDisplayString(turneringskategori.id), 9, _hoisted_17),
                    _createElementVNode("td", {
                      id: 'tournamentcategoriestable-row' + (index+1)
                    }, _toDisplayString(turneringskategori.turneringskategori_navn), 9, _hoisted_18),
                    _createElementVNode("td", {
                      id: 'tournamentcategoriestable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(turneringskategori.turneringskategori_pris), 9, _hoisted_19),
                    _createElementVNode("td", {
                      id: 'tournamentcategoriestable-row' + (index+1)
                    }, [
                      _createVNode(_component_va_button_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_button, {
                            color: "info",
                            class: "btn",
                            name: "edittournamentcategory",
                            onClick: ($event: any) => (_ctx.editTournamentCategory(turneringskategori.id, turneringskategori.documentId))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_va_button, {
                            icon: turneringskategori.turneringskategori_status ? 'check_box' : 'check_box_outline_blank',
                            color: turneringskategori.turneringskategori_status ? 'success' : 'rgb(255, 172, 10)',
                            class: "btn status-width",
                            name: "statuschangetournamentcategory",
                            onClick: ($event: any) => (_ctx.statusTournamentCategory(turneringskategori.id, turneringskategori.documentId))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(turneringskategori.turneringskategori_status ? 'Aktiv' : 'Inaktiv'), 1)
                            ]),
                            _: 2
                          }, 1032, ["icon", "color", "onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ], 8, _hoisted_20)
                  ]))
                }), 128))
              ])
            ])),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_va_button, {
            icon: "first_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.jumpToPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.turnToNewPage(-5)))
          }),
          _createVNode(_component_va_button, {
            icon: "chevron_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.turnToNewPage(-1)))
          }),
          _hoisted_23,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.currentPage) = $event)),
            onKeyup: _cache[13] || (_cache[13] = _withKeys(($event: any) => (_ctx.jumpToPage(this.currentPage)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.currentPage]
          ]),
          (_ctx.totalNumberOfPages === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_24, " af " + _toDisplayString(_ctx.totalNumberOfPages+1), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_25, " af " + _toDisplayString(_ctx.totalNumberOfPages), 1)),
          _createVNode(_component_va_button, {
            icon: "chevron_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.turnToNewPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.turnToNewPage(5)))
          }),
          _createVNode(_component_va_button, {
            icon: "last_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.jumpToPage(this.totalNumberOfPages)))
          }),
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_va_select, {
              class: "mr-2",
              modelValue: _ctx.pageSizeValueString,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.pageSizeValueString) = $event)),
              options: _ctx.pageSizeOptions,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editTournamentCategoryModal,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.editTournamentCategoryModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_va_button, {
                  class: "btn mr-2",
                  color: "success",
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$refs.editCategoryForm.validate(), (_ctx.validation ? (_ctx.newCategory ? _ctx.createTournamentCategory() : _ctx.updateTournamentCategory()) : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' }))))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.newCategory ? 'Opret kategori' : 'Gem'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_button, {
                  class: "btn ml-2",
                  color: "secondary",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => ((_ctx.editTournamentCategoryModal = false), _ctx.$Message.warning({ text: _ctx.newCategory ? 'Oprettelsen blev annulleret' : 'Redigeringen blev annulleret' })))
                }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_28, _toDisplayString(_ctx.newCategory ? 'Opret ny kategori' : 'Rediger kategori'), 1),
            _createVNode(_component_va_card, {
              color: "#afcfff",
              gradient: "",
              stripe: "",
              "stripe-color": "#2f5f4f"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_form, {
                  ref: "editCategoryForm",
                  onValidation: _cache[20] || (_cache[20] = ($event: any) => (_ctx.validation = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_va_input, {
                            type: "text",
                            modelValue: _ctx.tournamentCategoryData.categoryName,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.tournamentCategoryData.categoryName) = $event)),
                            label: "Turneringskategorinavn",
                            placeholder: "Navn",
                            rules: [(v) => v !== '' || 'Der mangler et kategorinavn'],
                            bordered: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_va_input, {
                            type: "number",
                            modelValue: _ctx.tournamentCategoryData.categoryPrice,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.tournamentCategoryData.categoryPrice) = $event)),
                            label: "Prisen for en turnering",
                            placeholder: "Beløb",
                            rules: [(v) => v.toString() !== '' || 'Der mangler et gyldigt beløb'],
                            bordered: ""
                          }, null, 8, ["modelValue", "rules"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger turneringskategorier']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Nulstil kolonner"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.rowColumnSort('reset')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.tournamentRowSearchInputValue,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.tournamentRowSearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[26] || (_cache[26] = _withKeys(($event: any) => (_ctx.findTournamentRow()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "person_search" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              class: "btn ml-2",
              rounded: false,
              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.findTournamentRow()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_40
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_component_va_select, {
              class: "ml-4",
              modelValue: _ctx.filterStatusStringValue2,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.filterStatusStringValue2) = $event)),
              options: _ctx.filterStatusStringOptions2,
              bordered: "",
              style: {"width":"75%"},
              label: "Række status"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("div", _hoisted_44, [
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.rowColumnName,
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.rowColumnName) = $event)),
              "array-value": "name",
              label: "Navn"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.rowColumnName,
              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.rowColumnName) = $event)),
              "array-value": "category",
              label: "Kategori"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.rowColumnName,
              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.rowColumnName) = $event)),
              "array-value": "region",
              label: "Region"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.rowColumnName,
              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.rowColumnName) = $event)),
              "array-value": "minTeams",
              label: "Min. # hold"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.rowColumnName,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.rowColumnName) = $event)),
              "array-value": "maxTeams",
              label: "Maks. # hold"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.rowColumnName,
              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.rowColumnName) = $event)),
              "array-value": "sets",
              label: "# sæt"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.rowColumnName,
              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.rowColumnName) = $event)),
              "array-value": "teamsPerClub",
              label: "# hold per klub"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.rowColumnName,
              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.rowColumnName) = $event)),
              "array-value": "players",
              label: "# spillere"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.rowColumnName,
              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.rowColumnName) = $event)),
              "array-value": "maxPlayers",
              label: "Maks. # spillere"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.rowColumnName,
              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.rowColumnName) = $event)),
              "array-value": "promotions",
              label: "# oprykninger"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createElementVNode("table", _hoisted_47, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_48,
                    _withDirectives(_createElementVNode("th", {
                      class: "clickAble",
                      onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.rowColumnSort('name')))
                    }, "Navn", 512), [
                      [_vShow, _ctx.showRowColumn('name')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "clickAble",
                      onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.rowColumnSort('category')))
                    }, "Kategori", 512), [
                      [_vShow, _ctx.showRowColumn('category')]
                    ]),
                    _withDirectives(_createElementVNode("th", null, "Region", 512), [
                      [_vShow, _ctx.showRowColumn('region')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "center clickAble",
                      onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.rowColumnSort('minTeams')))
                    }, "Min. # hold", 512), [
                      [_vShow, _ctx.showRowColumn('minTeams')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "center clickAble",
                      onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.rowColumnSort('maxTeams')))
                    }, "Maks. # hold", 512), [
                      [_vShow, _ctx.showRowColumn('maxTeams')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "center clickAble",
                      onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.rowColumnSort('sets')))
                    }, "# sæt", 512), [
                      [_vShow, _ctx.showRowColumn('sets')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "center clickAble",
                      onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.rowColumnSort('teamsPerClub')))
                    }, "# hold per klub", 512), [
                      [_vShow, _ctx.showRowColumn('teamsPerClub')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "center clickAble",
                      onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.rowColumnSort('players')))
                    }, "# spillere", 512), [
                      [_vShow, _ctx.showRowColumn('players')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "center clickAble",
                      onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.rowColumnSort('maxPlayers')))
                    }, "Maks # spillere", 512), [
                      [_vShow, _ctx.showRowColumn('maxPlayers')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "center clickAble",
                      onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.rowColumnSort('promotions')))
                    }, "# oprykninger", 512), [
                      [_vShow, _ctx.showRowColumn('promotions')]
                    ]),
                    _hoisted_49
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.raekkes, (raekke, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: raekke.id
                  }, [
                    _createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1),
                      hidden: ""
                    }, _toDisplayString(raekke.id), 9, _hoisted_50),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1)
                    }, _toDisplayString(raekke.raekke_navn), 9, _hoisted_51), [
                      [_vShow, _ctx.showRowColumn('name')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1)
                    }, _toDisplayString(raekke.turneringskategori_id.turneringskategori_navn), 9, _hoisted_52), [
                      [_vShow, _ctx.showRowColumn('category')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1)
                    }, _toDisplayString(raekke.region_id.length === 9 ? 'Alle regioner' : _ctx.getRegions(raekke.region_id)), 9, _hoisted_53), [
                      [_vShow, _ctx.showRowColumn('region')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(raekke.raekke_minhold), 9, _hoisted_54), [
                      [_vShow, _ctx.showRowColumn('minTeams')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(raekke.raekke_maxhold), 9, _hoisted_55), [
                      [_vShow, _ctx.showRowColumn('maxTeams')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(raekke.raekke_antalsaet), 9, _hoisted_56), [
                      [_vShow, _ctx.showRowColumn('sets')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(raekke.raekke_holdprklub), 9, _hoisted_57), [
                      [_vShow, _ctx.showRowColumn('teamsPerClub')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(raekke.raekke_antalspillere), 9, _hoisted_58), [
                      [_vShow, _ctx.showRowColumn('players')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(raekke.raekke_maxspillere), 9, _hoisted_59), [
                      [_vShow, _ctx.showRowColumn('maxPlayers')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(raekke.raekke_oprykning), 9, _hoisted_60), [
                      [_vShow, _ctx.showRowColumn('promotions')]
                    ]),
                    _createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1)
                    }, [
                      _createVNode(_component_va_button_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_button, {
                            color: "info",
                            class: "btn",
                            name: "edittournamentrow",
                            onClick: ($event: any) => (_ctx.editTournamentRow(raekke.id, raekke.documentId))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_62
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_va_button, {
                            icon: raekke.raekke_status ? 'check_box' : 'check_box_outline_blank',
                            color: raekke.raekke_status ? 'success' : 'rgb(255, 172, 10)',
                            class: "btn status-width",
                            name: "statuschangetournamentrow",
                            onClick: ($event: any) => (_ctx.statusTournamentRow(raekke.id, raekke.documentId))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(raekke.raekke_status ? 'Aktiv' : 'Inaktiv'), 1)
                            ]),
                            _: 2
                          }, 1032, ["icon", "color", "onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ], 8, _hoisted_61)
                  ]))
                }), 128))
              ])
            ])),
        _createElementVNode("div", _hoisted_63, [
          _createVNode(_component_va_button, {
            icon: "first_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.jumpToPage2(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.turnToNewPage2(-5)))
          }),
          _createVNode(_component_va_button, {
            icon: "chevron_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.turnToNewPage2(-1)))
          }),
          _hoisted_64,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.currentPage2) = $event)),
            type: "number",
            onKeyup: _cache[52] || (_cache[52] = _withKeys(($event: any) => (_ctx.jumpToPage2(this.currentPage2)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.currentPage2]
          ]),
          (_ctx.totalNumberOfPages2 === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_65, " af " + _toDisplayString(_ctx.totalNumberOfPages2 + 1), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_66, " af " + _toDisplayString(_ctx.totalNumberOfPages2), 1)),
          _createVNode(_component_va_button, {
            icon: "chevron_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.turnToNewPage2(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.turnToNewPage2(5)))
          }),
          _createVNode(_component_va_button, {
            icon: "last_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.jumpToPage2(this.totalNumberOfPages2)))
          }),
          _hoisted_67,
          _createElementVNode("div", _hoisted_68, [
            _createVNode(_component_va_select, {
              class: "mr-2",
              modelValue: _ctx.pageSizeValueString2,
              "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.pageSizeValueString2) = $event)),
              options: _ctx.pageSizeOptions2,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editTournamentRowModal,
          "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.editTournamentRowModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createVNode(_component_va_button, {
                  class: "btn mr-2",
                  color: "success",
                  onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.$refs.editRowForm.validate(), (_ctx.validation ? _ctx.updateTournamentRow() : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' }))))
                }, {
                  default: _withCtx(() => [
                    _hoisted_82
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_button, {
                  class: "btn ml-2",
                  color: "secondary",
                  onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), _ctx.cancelTournamentRowEdit()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_83
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_69,
            _createVNode(_component_va_card, {
              color: "#afcfff",
              gradient: "",
              stripe: "",
              "stripe-color": "#2f5f4f"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_form, {
                  ref: "editRowForm",
                  onValidation: _cache[64] || (_cache[64] = ($event: any) => (_ctx.validation = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                          _createVNode(_component_va_input, {
                            type: "text",
                            modelValue: _ctx.tournamentRowData.rowName,
                            "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.tournamentRowData.rowName) = $event)),
                            label: "Turneringsrækkenavn",
                            placeholder: "Navn",
                            rules: [(v) => v !== '' || 'Rækken mangler et navn'],
                            bordered: ""
                          }, null, 8, ["modelValue", "rules"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, [
                          _createVNode(_component_va_input, {
                            class: "center",
                            type: "number",
                            modelValue: _ctx.tournamentRowData.numberOfSets,
                            "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.tournamentRowData.numberOfSets) = $event)),
                            label: "Først til af # vundne sæt",
                            placeholder: "Nr.",
                            rules: [(v) => v.toString() !== '' || 'Antal sæt er ikke angivet'],
                            bordered: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          _createVNode(_component_va_input, {
                            class: "center",
                            type: "number",
                            modelValue: _ctx.tournamentRowData.minNumberOfTeams,
                            "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.tournamentRowData.minNumberOfTeams) = $event)),
                            label: "Minimum antal hold",
                            placeholder: "Nr.",
                            rules: [(v) => v.toString() !== '' || 'Minimum antal hold er ikke angivet'],
                            bordered: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _createVNode(_component_va_input, {
                            class: "center",
                            type: "number",
                            modelValue: _ctx.tournamentRowData.maxNumberOfTeams,
                            "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.tournamentRowData.maxNumberOfTeams) = $event)),
                            label: "Maksimum antal hold",
                            placeholder: "Nr.",
                            rules: [(v) => v.toString() !== '' || 'Maksimum antal hold er ikke angivet'],
                            bordered: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_77, [
                          _createVNode(_component_va_input, {
                            class: "center",
                            type: "number",
                            modelValue: _ctx.tournamentRowData.numberOfTeamsPerClub,
                            "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.tournamentRowData.numberOfTeamsPerClub) = $event)),
                            label: "Antal hold per klub",
                            placeholder: "Nr.",
                            rules: [(v) => v.toString() !== '' || 'Antal hold per klub er ikke angivet'],
                            bordered: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_78, [
                          _createVNode(_component_va_input, {
                            class: "center",
                            type: "number",
                            modelValue: _ctx.tournamentRowData.numberOfPlayers,
                            "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.tournamentRowData.numberOfPlayers) = $event)),
                            label: "Antal spillere per hold",
                            placeholder: "Nr.",
                            rules: [(v) => v.toString() !== '' || 'Spillere per hold er ikke angivet'],
                            bordered: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_79, [
                          _createVNode(_component_va_input, {
                            class: "center",
                            type: "number",
                            modelValue: _ctx.tournamentRowData.maxNumberOfPlayers,
                            "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.tournamentRowData.maxNumberOfPlayers) = $event)),
                            label: "Maks. antal spillere per hold",
                            placeholder: "Nr.",
                            rules: [(v) => v.toString() !== '' || 'Maksimum antal spillere per hold er ikke angivet'],
                            bordered: ""
                          }, null, 8, ["modelValue", "rules"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger turneringsrækker']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_84, [
        _createElementVNode("div", _hoisted_85, [
          _createElementVNode("div", _hoisted_86, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Nulstil kolonner"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.ruleColumnSort('reset')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createVNode(_component_va_select, {
              label: "Vis reglerne for...",
              modelValue: _ctx.rulesCategoryFilterValue,
              "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.rulesCategoryFilterValue) = $event)),
              options: _ctx.rulesCategoryFilterOptions,
              "track-by": (v) => v.id,
              "text-by": (v) => v.value
            }, null, 8, ["modelValue", "options", "track-by", "text-by"])
          ]),
          _createElementVNode("div", _hoisted_88, [
            _createVNode(_component_va_button, {
              onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.newRule()))
            }, {
              default: _withCtx(() => [
                _hoisted_89
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_91, [
              _createElementVNode("table", _hoisted_92, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      onClick: _cache[71] || (_cache[71] = ($event: any) => (_ctx.ruleColumnSort('category'))),
                      class: "clickAble"
                    }, "Kategori"),
                    _hoisted_93,
                    _createElementVNode("th", {
                      onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.ruleColumnSort('result'))),
                      class: "clickAble"
                    }, "Resultat"),
                    _createElementVNode("th", {
                      onClick: _cache[73] || (_cache[73] = ($event: any) => (_ctx.ruleColumnSort('point'))),
                      class: "clickAble"
                    }, "Point tildelt"),
                    _hoisted_94
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rules, (rule) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: rule.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(rule.turneringskategori_id.turneringskategori_navn), 1),
                      _createElementVNode("td", null, _toDisplayString(rule.regions.length === 9 ? 'Alle regioner' : _ctx.getRegions(rule.regions)), 1),
                      _createElementVNode("td", null, _toDisplayString(rule.turneringsregler_resultat), 1),
                      _createElementVNode("td", null, _toDisplayString(rule.turneringsregler_point), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_va_button_group, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_va_button, {
                              color: "info",
                              class: "btn",
                              rounded: false,
                              onClick: ($event: any) => (_ctx.editRule(rule.documentId))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_95
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_va_button, {
                              color: "danger",
                              class: "btn",
                              rounded: false,
                              onClick: ($event: any) => (_ctx.deleteWarning(rule.id, rule.documentId))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_96
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.rulesDeleteWarningModal,
          "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.rulesDeleteWarningModal) = $event)),
          "overlay-opacity": "0.5",
          "hide-default-actions": ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _createVNode(_component_va_button, {
                  class: "btn mr-4",
                  color: "danger",
                  onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.deleteRule(this.currentDeletingRuleDocumentId)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_100
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_button, {
                  class: "btn ml-4",
                  color: "secondary",
                  onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.rulesDeleteWarningModal = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_101
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_97
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.rulesModal,
          "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.rulesModal) = $event)),
          "overlay-opacity": "0.5",
          "hide-default-actions": "",
          "no-dismiss": "",
          size: "large"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("div", _hoisted_110, [
                _createVNode(_component_va_button, {
                  class: "mr-2",
                  color: "success",
                  onClick: _cache[82] || (_cache[82] = ($event: any) => (_ctx.$refs.tournamentRulesForm.validate(), (_ctx.validation ? (_ctx.editingExistingRule ? _ctx.updateRule() : _ctx.createNewRule()) : _ctx.$Message.danger({ text: 'Et eller flere felter er ikke udfyldt korrekt' }))))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.editingExistingRule ? 'Gem' : 'Opret regel'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_button, {
                  class: "ml-2",
                  color: "secondary",
                  onClick: _cache[83] || (_cache[83] = ($event: any) => (_ctx.rulesModal = false, _ctx.$Message.warning({ text: _ctx.editingExistingRule ? 'Redigeringen blev annulleret' : 'Oprettelsen blev annulleret' })))
                }, {
                  default: _withCtx(() => [
                    _hoisted_111
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_102, _toDisplayString(_ctx.editingExistingRule ? 'Rediger regel' : 'Opret ny regel'), 1),
            _createVNode(_component_va_card, {
              color: "#afcfff",
              gradient: "",
              stripe: "",
              "stripe-color": "#2f5f4f"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_form, {
                  ref: "tournamentRulesForm",
                  onValidation: _cache[81] || (_cache[81] = ($event: any) => (_ctx.validation = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("div", _hoisted_104, [
                        _createElementVNode("div", _hoisted_105, [
                          _createVNode(_component_va_select, {
                            label: "Turneringskategori",
                            modelValue: _ctx.tournamentRuleData.categoryValue,
                            "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.tournamentRuleData.categoryValue) = $event)),
                            options: _ctx.categoryOptions,
                            "track-by": (v) => v.categoryId,
                            "text-by": (v) => v.categoryName,
                            searchable: "",
                            rules: [(v) => v.categoryId !== 0 || 'Vælg venligst en kategori']
                          }, null, 8, ["modelValue", "options", "track-by", "text-by", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_106, [
                          _createVNode(_component_va_select, {
                            label: "Regioner",
                            modelValue: _ctx.tournamentRuleData.regionValue,
                            "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.tournamentRuleData.regionValue) = $event)),
                            options: _ctx.regionOptions,
                            "track-by": (v) => v.regionId,
                            "text-by": (v) => v.regionName,
                            searchable: "",
                            bordered: "",
                            multiple: "",
                            rules: [(v) => v.length > 0 || 'Vælg venligst mindst en region']
                          }, null, 8, ["modelValue", "options", "track-by", "text-by", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_107, [
                          _createVNode(_component_va_input, {
                            label: "Resultat",
                            modelValue: _ctx.tournamentRuleData.tournamentResult,
                            "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.tournamentRuleData.tournamentResult) = $event)),
                            type: "text",
                            bordered: "",
                            rules: [(v) => v !== '' || 'Der mangler et resultat']
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_108, [
                          _createVNode(_component_va_input, {
                            label: "Point tildelt",
                            modelValue: _ctx.tournamentRuleData.pointsAwarded,
                            "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.tournamentRuleData.pointsAwarded) = $event)),
                            modelModifiers: { number: true },
                            type: "number",
                            bordered: "",
                            rules: [(v) => v.toString() !== '' || 'Point er ikke angivet']
                          }, null, 8, ["modelValue", "rules"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }),
            _createVNode(_component_va_modal, {
              modelValue: _ctx.rulesWarningModal,
              "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.rulesWarningModal) = $event)),
              "overlay-opacity": "0.5",
              "hide-default-actions": ""
            }, {
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_118, [
                  _createElementVNode("div", _hoisted_119, [
                    _createVNode(_component_va_button, {
                      class: "mr-2",
                      color: "warning",
                      onClick: _cache[84] || (_cache[84] = ($event: any) => {_ctx.checkedRuleFlag = true; _ctx.rulesWarningModal = false; (_ctx.editingExistingRule ? _ctx.updateRule() : _ctx.createNewRule())})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_120
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_va_button, {
                      class: "ml-2",
                      color: "secondary",
                      onClick: _cache[85] || (_cache[85] = ($event: any) => (_ctx.rulesWarningModal = false))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_121
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _hoisted_112,
                _createElementVNode("div", _hoisted_113, [
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("div", _hoisted_115, [
                      _createElementVNode("p", _hoisted_116, "Den " + _toDisplayString(_ctx.editingExistingRule ? 'opdaterede' : 'ny') + " regel er identisk med en anden regel.", 1),
                      _createElementVNode("p", _hoisted_117, "Klik Ok hvis du vil " + _toDisplayString(_ctx.editingExistingRule ? 'opdatere' : 'oprette') + " regel alligevel, eller klik annuller for at vende tilbage og forsøge igen.", 1)
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger turneringsregler']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_122, [
        _createElementVNode("div", _hoisted_123, [
          _createElementVNode("div", _hoisted_124, [
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_125, _toDisplayString(_ctx.error), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_126, [
                  (!_ctx.submitted3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                        _createElementVNode("div", _hoisted_128, [
                          _createVNode(_component_va_form, {
                            ref: "form",
                            id: "newtournamentroundsform",
                            onSubmit: _ctx.handleSubmit
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_129, [
                                _createElementVNode("div", _hoisted_130, [
                                  _createElementVNode("div", _hoisted_131, [
                                    _createVNode(_component_va_select, {
                                      class: "mb-4",
                                      modelValue: _ctx.tournamentSeasonTextValue,
                                      "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.tournamentSeasonTextValue) = $event)),
                                      options: _ctx.tournamentSeasonTextOptions,
                                      label: "Sæson",
                                      bordered: ""
                                    }, null, 8, ["modelValue", "options"])
                                  ]),
                                  _createElementVNode("div", _hoisted_132, [
                                    _createVNode(_component_va_select, {
                                      class: "mb-4",
                                      modelValue: _ctx.tournamentCategoryTitleValue,
                                      "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((_ctx.tournamentCategoryTitleValue) = $event)),
                                      options: _ctx.tournamentCategoryTitleOptions,
                                      label: "Kategori",
                                      bordered: ""
                                    }, null, 8, ["modelValue", "options"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_133, [
                                  _createElementVNode("div", _hoisted_134, [
                                    _createVNode(_component_va_button, {
                                      size: "medium",
                                      class: "btn ml-2",
                                      rounded: false,
                                      onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.addNewTournamentRoundToBeCreated()))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_135
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tournamentRoundsToBeCreated, (tournamentRoundToBeCreatedItem, indexRoundItem) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "row",
                                    key: indexRoundItem
                                  }, [
                                    _createElementVNode("div", _hoisted_136, [
                                      _createVNode(_component_va_chip, {
                                        modelValue: tournamentRoundToBeCreatedItem.tagNotClosed,
                                        "onUpdate:modelValue": ($event: any) => ((tournamentRoundToBeCreatedItem.tagNotClosed) = $event),
                                        onClick: ($event: any) => (_ctx.editPropertiesOfNewTournamentRoundToBeCreated(indexRoundItem)),
                                        size: "medium",
                                        closeable: "",
                                        shadow: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Runde #" + _toDisplayString((indexRoundItem + 1).toString()), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onClick"])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          }, 8, ["onSubmit"])
                        ]),
                        _createElementVNode("div", _hoisted_137, [
                          _createElementVNode("div", _hoisted_138, [
                            _createVNode(_component_va_button, {
                              class: "btn",
                              color: "success",
                              size: "large",
                              onClick: _cache[91] || (_cache[91] = ($event: any) => {_ctx.$refs.form.validate(); _ctx.createTournamentRounds()})
                            }, {
                              default: _withCtx(() => [
                                _hoisted_139
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_140, [
                        _hoisted_141,
                        _createVNode(_component_va_button, {
                          class: "btn",
                          color: "success",
                          size: "large",
                          onClick: _cache[92] || (_cache[92] = ($event: any) => (_ctx.newCreateTournamentRounds()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_142
                          ]),
                          _: 1
                        })
                      ]))
                ]))
          ]),
          _createVNode(_component_va_modal, {
            modelValue: _ctx.editTournamentRoundToBeCreatedModal,
            "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => ((_ctx.editTournamentRoundToBeCreatedModal) = $event)),
            size: "large",
            "hide-default-actions": "",
            "overlay-opacity": "0.5",
            "no-dismiss": ""
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_va_button, {
                class: "btn mr-4",
                color: "success",
                onClick: _cache[98] || (_cache[98] = ($event: any) => (_ctx.updateTournamentRoundToBeCreated(_ctx.indexOfEditedTournamentRoundToBeCreated) ? _ctx.$Message.success({ text: 'Ændringerne af rundens oplysninger blev gemt' }) : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' })))
              }, {
                default: _withCtx(() => [
                  _hoisted_150
                ]),
                _: 1
              }),
              _createVNode(_component_va_button, {
                class: "btn mr-4",
                color: "secondary",
                onClick: _cache[99] || (_cache[99] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), _ctx.cancelTournamentRoundToBeCreatedEdit()))
              }, {
                default: _withCtx(() => [
                  _hoisted_151
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_143, [
                _hoisted_144,
                _createElementVNode("div", _hoisted_145, [
                  _createElementVNode("div", _hoisted_146, [
                    _createElementVNode("h6", null, _toDisplayString(_ctx.editTournamentRoundToBeCreatedDateValue.getDate().toString()) + "/" + _toDisplayString((_ctx.editTournamentRoundToBeCreatedDateValue.getMonth() + 1).toString()) + "-" + _toDisplayString(_ctx.editTournamentRoundToBeCreatedDateValue.getFullYear().toString()), 1),
                    _createVNode(_component_va_date_picker, {
                      mode: "single",
                      modelValue: _ctx.editTournamentRoundToBeCreatedDateValue,
                      "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.editTournamentRoundToBeCreatedDateValue) = $event)),
                      "highlight-weekend": "",
                      "show-other-months": "",
                      view: _ctx.editTournamentRoundToBeCreatedDateView,
                      "onUpdate:view": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.editTournamentRoundToBeCreatedDateView) = $event)),
                      "onClick:day": _cache[95] || (_cache[95] = ($event: any) => (_ctx.tournamentRoundToBeCreatedEditDateDayCellClicked($event))),
                      "weekday-names": [ 'Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø' ]
                    }, null, 8, ["modelValue", "view"])
                  ]),
                  _createElementVNode("div", _hoisted_147, [
                    _createVNode(_component_va_time_input, {
                      modelValue: _ctx.editTournamentRoundToBeCreatedDateValue,
                      "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => ((_ctx.editTournamentRoundToBeCreatedDateValue) = $event)),
                      "manual-input": "",
                      leftIcon: "",
                      clearable: "",
                      "clear-value": new Date(),
                      label: "Klokkeslæt"
                    }, null, 8, ["modelValue", "clear-value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_148, [
                  _createElementVNode("div", _hoisted_149, [
                    _createVNode(_component_va_input, {
                      class: "mb-4",
                      type: "numeric",
                      modelValue: _ctx.editTournamentRoundToBeCreatedNumberOfMatchesValue,
                      "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => ((_ctx.editTournamentRoundToBeCreatedNumberOfMatchesValue) = $event)),
                      label: "Antal kampe",
                      placeholder: "Antal",
                      bordered: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Opret turneringsrunder']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_152, [
        _createElementVNode("div", _hoisted_153, [
          _createElementVNode("div", _hoisted_154, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Nulstil kolonner"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[101] || (_cache[101] = ($event: any) => (_ctx.matchColumnSort('reset')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_155, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.tournamentMatchScheduleSearchInputValue,
              "onUpdate:modelValue": _cache[102] || (_cache[102] = ($event: any) => ((_ctx.tournamentMatchScheduleSearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[103] || (_cache[103] = _withKeys(($event: any) => (_ctx.findTournamentMatchSchedule()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "person_search" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              class: "btn ml-2",
              rounded: false,
              onClick: _cache[104] || (_cache[104] = ($event: any) => (_ctx.findTournamentMatchSchedule()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_156
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_157, [
            _createVNode(_component_va_select, {
              class: "ml-4",
              modelValue: _ctx.filterSeasonTextValue,
              "onUpdate:modelValue": _cache[105] || (_cache[105] = ($event: any) => ((_ctx.filterSeasonTextValue) = $event)),
              options: _ctx.filterSeasonTextOptions,
              bordered: "",
              style: {"width":"75%"},
              label: "Sæson"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_158, [
            _createVNode(_component_va_button_dropdown, {
              size: "medium",
              class: "btn ml-2",
              split: "",
              label: "Opret sæson",
              rounded: false,
              onMainButtonClick: _cache[108] || (_cache[108] = ($event: any) => (_ctx.editCreateTournamentSeason())),
              onClick: _cache[109] || (_cache[109] = ($event: any) => (_ctx.editCreateTournamentSeasonMatchPlanAlert()))
            }, {
              label: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "add_circle_outline" }),
                _hoisted_159
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_160, [
                  _createVNode(_component_va_chip, {
                    class: "mr-2",
                    square: "",
                    onClick: _cache[106] || (_cache[106] = ($event: any) => (_ctx.editCreateNewTournamentSeason()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_icon, { name: "start" }),
                      _hoisted_161
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_162, [
                  _createVNode(_component_va_chip, {
                    class: "mr-2",
                    square: "",
                    onClick: _cache[107] || (_cache[107] = ($event: any) => (_ctx.editCreateTournamentSeasonMatchPlan()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_icon, { name: "gavel" }),
                      _hoisted_163
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn ml-2",
              color: "danger",
              onClick: _cache[110] || (_cache[110] = ($event: any) => (_ctx.editFinalizeTournamentSeason()))
            }, {
              default: _withCtx(() => [
                _hoisted_164
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn ml-2",
              color: "success",
              onClickOnce: _cache[111] || (_cache[111] = ($event: any) => (_ctx.templateGetTeams($event, true, 'tab1'))),
              onClick: _cache[112] || (_cache[112] = ($event: any) => (_ctx.createNewMatchModal = true))
            }, {
              default: _withCtx(() => [
                _hoisted_165
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_va_modal, {
            modelValue: _ctx.editFinalizeTournamentSeasonModal,
            "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event: any) => ((_ctx.editFinalizeTournamentSeasonModal) = $event)),
            size: "large",
            "hide-default-actions": "",
            "overlay-opacity": "0.5",
            "no-dismiss": ""
          }, {
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_171, [
                _createElementVNode("div", _hoisted_172, [
                  _createVNode(_component_va_button, {
                    class: "btn mr-2",
                    color: "success",
                    onClick: _cache[115] || (_cache[115] = ($event: any) => (_ctx.saveCurrentMatchesTeamRankings())),
                    disabled: _ctx.disableStartButtonWhenSavingCurrentMatchesTeamRankings
                  }, {
                    default: _withCtx(() => [
                      _hoisted_173
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_va_progress_circle, {
                    class: "mb-2",
                    modelValue: _ctx.currentMatchesTeamRankingsSavedProgressValue,
                    color: "#cf11a1",
                    thickness: 0.2,
                    size: 54
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("b", null, _toDisplayString(_ctx.currentMatchesTeamRankingsSavedProgressValue + '%'), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "thickness"]),
                  _createVNode(_component_va_button, {
                    class: "btn mr-2",
                    color: "secondary",
                    onClick: _cache[116] || (_cache[116] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), _ctx.cancelTournamentSeasonFinalizationEdit()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_174
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            default: _withCtx(() => [
              _hoisted_166,
              _createVNode(_component_va_card, {
                color: "#afcfff",
                gradient: "",
                stripe: "",
                "stripe-color": "#2f5f4f"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_form, { ref: "finalizeSeasonForm" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_167, [
                        _createElementVNode("div", _hoisted_168, [
                          _createElementVNode("div", _hoisted_169, [
                            _createVNode(_component_va_select, {
                              class: "mr-4",
                              modelValue: _ctx.tournamentSeasonTextValue,
                              "onUpdate:modelValue": _cache[113] || (_cache[113] = ($event: any) => ((_ctx.tournamentSeasonTextValue) = $event)),
                              options: _ctx.tournamentSeasonTextOptions,
                              label: "Vælg sæson",
                              bordered: "",
                              style: {"width":"75%","margin-bottom":"4px"}
                            }, null, 8, ["modelValue", "options"])
                          ]),
                          _createElementVNode("div", _hoisted_170, [
                            _createVNode(_component_va_select, {
                              class: "ml-4",
                              modelValue: _ctx.tournamentSeasonSeriesTextValue,
                              "onUpdate:modelValue": _cache[114] || (_cache[114] = ($event: any) => ((_ctx.tournamentSeasonSeriesTextValue) = $event)),
                              options: _ctx.tournamentSeasonSeriesTextOptions,
                              label: "Vælg serie",
                              bordered: "",
                              style: {"width":"75%","margin-bottom":"4px"}
                            }, null, 8, ["modelValue", "options"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_va_modal, {
            modelValue: _ctx.editCreateNewTournamentSeasonModal,
            "onUpdate:modelValue": _cache[124] || (_cache[124] = ($event: any) => ((_ctx.editCreateNewTournamentSeasonModal) = $event)),
            size: "large",
            "hide-default-actions": "",
            "overlay-opacity": "0.5",
            "no-dismiss": ""
          }, {
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_183, [
                _createElementVNode("div", _hoisted_184, [
                  _createVNode(_component_va_button, {
                    class: "btn mr-2",
                    color: "success",
                    onClick: _cache[122] || (_cache[122] = ($event: any) => (_ctx.showTeamRankingsAdjustableDivisioning()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_185
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_va_button, {
                    class: "btn mr-2",
                    color: "secondary",
                    onClick: _cache[123] || (_cache[123] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), _ctx.cancelCreateNewTournamentSeasonEdit()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_186
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            default: _withCtx(() => [
              _hoisted_175,
              _createVNode(_component_va_card, {
                color: "#afcfff",
                gradient: "",
                stripe: "",
                "stripe-color": "#2f5f4f"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_form, { ref: "startingNewSeasonForm" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_176, [
                        _createElementVNode("div", _hoisted_177, [
                          _createElementVNode("div", _hoisted_178, [
                            _createVNode(_component_va_select, {
                              class: "ml-4",
                              modelValue: _ctx.tournamentSeasonTextValue,
                              "onUpdate:modelValue": _cache[118] || (_cache[118] = ($event: any) => ((_ctx.tournamentSeasonTextValue) = $event)),
                              options: _ctx.tournamentSeasonTextOptions,
                              label: "Vælg sæson med stillinger-resultatet",
                              bordered: "",
                              style: {"width":"75%","margin-bottom":"4px"}
                            }, null, 8, ["modelValue", "options"])
                          ]),
                          _createElementVNode("div", _hoisted_179, [
                            _createVNode(_component_va_select, {
                              class: "ml-4",
                              modelValue: _ctx.newTournamentSeasonTextValue,
                              "onUpdate:modelValue": _cache[119] || (_cache[119] = ($event: any) => ((_ctx.newTournamentSeasonTextValue) = $event)),
                              options: _ctx.tournamentSeasonTextOptions,
                              label: "Vælg sæson, der skal startes",
                              bordered: "",
                              style: {"width":"75%","margin-bottom":"4px"}
                            }, null, 8, ["modelValue", "options"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_180, [
                          _createElementVNode("div", _hoisted_181, [
                            _createVNode(_component_va_select, {
                              class: "ml-4",
                              modelValue: _ctx.tournamentCategoryTitleValue,
                              "onUpdate:modelValue": _cache[120] || (_cache[120] = ($event: any) => ((_ctx.tournamentCategoryTitleValue) = $event)),
                              options: _ctx.tournamentCategoryTitleOptions,
                              label: "Vælg kategori, der skal startes",
                              bordered: "",
                              style: {"width":"75%","margin-bottom":"4px"}
                            }, null, 8, ["modelValue", "options"])
                          ]),
                          _createElementVNode("div", _hoisted_182, [
                            _createVNode(_component_va_checkbox, {
                              class: "ml-4",
                              modelValue: _ctx.advancedTournamentTeamsNewSeasonDivisionPlacementsModeFlag,
                              "onUpdate:modelValue": _cache[121] || (_cache[121] = ($event: any) => ((_ctx.advancedTournamentTeamsNewSeasonDivisionPlacementsModeFlag) = $event)),
                              label: "Avanceret modus",
                              style: {"margin-top":"8px","margin-bottom":"8px","padding":"8px"}
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_va_modal, {
            modelValue: _ctx.editSuggestedTournamentSeasonTeamPlacementsModal,
            "onUpdate:modelValue": _cache[127] || (_cache[127] = ($event: any) => ((_ctx.editSuggestedTournamentSeasonTeamPlacementsModal) = $event)),
            size: "large",
            "hide-default-actions": "",
            "overlay-opacity": "0.5",
            "no-dismiss": ""
          }, {
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_189, [
                _createElementVNode("div", _hoisted_190, [
                  _createVNode(_component_va_button, {
                    class: "btn mr-2",
                    color: "success",
                    onClick: _cache[125] || (_cache[125] = ($event: any) => (_ctx.acceptTournamentSeasonTeamPlacements()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_191
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_va_button, {
                    class: "btn mr-2",
                    color: "secondary",
                    onClick: _cache[126] || (_cache[126] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), _ctx.cancelSuggestedTournamentSeasonTeamPlacementsEdit()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_192
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            default: _withCtx(() => [
              _hoisted_187,
              _createVNode(_component_va_card, {
                color: "#afcfff",
                gradient: "",
                stripe: "",
                "stripe-color": "#2f5f4f"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_form, { ref: "editsuggestedTournamentSeasonTeamPlacementsModal" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_188, [
                        _createVNode(_component_va_scroll_container, {
                          vertical: "",
                          color: "primary",
                          style: {"max-height":"480px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_va_list, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getNewTournamentSeasonTeamsRowIdsValues(), (tRowId, index9) => {
                                  return (_openBlock(), _createBlock(_component_va_list_item, {
                                    key: index9,
                                    class: "list__label"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_va_list_item_section, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_va_list_item_label, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.getNewTournamentSeasonTeamsRowIdToRowName(tRowId)) + " ", 1),
                                              _createVNode(_component_va_list, null, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getNewTournamentSeasonTeamsRowsTextValues(tRowId), (newTournamentSeasonTeamsRowTextValues, index8) => {
                                                    return (_openBlock(), _createBlock(_component_va_list_item, {
                                                      class: "list__item",
                                                      key: index8,
                                                      onClick: ($event: any) => (_ctx.editOneTournamentSeasonTeamPlacement(newTournamentSeasonTeamsRowTextValues))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_va_list_item_section, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_va_list_item_label, null, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(newTournamentSeasonTeamsRowTextValues.placement) + ". " + _toDisplayString(newTournamentSeasonTeamsRowTextValues.teamname) + " - " + _toDisplayString(newTournamentSeasonTeamsRowTextValues.text), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_va_modal, {
            modelValue: _ctx.editOneTournamentSeasonTeamPlacementModal,
            "onUpdate:modelValue": _cache[132] || (_cache[132] = ($event: any) => ((_ctx.editOneTournamentSeasonTeamPlacementModal) = $event)),
            size: "large",
            "hide-default-actions": "",
            "overlay-opacity": "0.5",
            "no-dismiss": ""
          }, {
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_198, [
                _createElementVNode("div", _hoisted_199, [
                  _createVNode(_component_va_button, {
                    class: "btn mr-2",
                    color: "success",
                    onClick: _cache[130] || (_cache[130] = ($event: any) => (_ctx.changeOneTournamentSeasonTeamPlacement()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_200
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_va_button, {
                    class: "btn mr-2",
                    color: "secondary",
                    onClick: _cache[131] || (_cache[131] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), _ctx.cancelOneTournamentSeasonTeamPlacementEdit()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_201
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("h6", _hoisted_193, "Ændre placering og division for holdet " + _toDisplayString(_ctx.teamToBeChangedTournamentSeasonTeamPlacement.text), 1),
              _createVNode(_component_va_card, {
                color: "#afcfff",
                gradient: "",
                stripe: "",
                "stripe-color": "#2f5f4f"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_form, { ref: "editoneTournamentSeasonTeamPlacementModal" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_194, [
                        _createElementVNode("div", _hoisted_195, [
                          _createElementVNode("div", _hoisted_196, [
                            _createVNode(_component_va_select, {
                              class: "mr-4",
                              modelValue: _ctx.newTournamentRowTextValue,
                              "onUpdate:modelValue": _cache[128] || (_cache[128] = ($event: any) => ((_ctx.newTournamentRowTextValue) = $event)),
                              options: _ctx.newTournamentRowTextOptions,
                              label: "Vælg ny division",
                              bordered: "",
                              style: {"width":"75%","margin-bottom":"4px"}
                            }, null, 8, ["modelValue", "options"])
                          ]),
                          _createElementVNode("div", _hoisted_197, [
                            _createVNode(_component_va_select, {
                              class: "mr-4",
                              modelValue: _ctx.newPlacementTextValue,
                              "onUpdate:modelValue": _cache[129] || (_cache[129] = ($event: any) => ((_ctx.newPlacementTextValue) = $event)),
                              options: _ctx.newPlacementTextOptions,
                              label: "Vælg ny placering",
                              bordered: "",
                              style: {"width":"75%","margin-bottom":"4px"}
                            }, null, 8, ["modelValue", "options"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_va_modal, {
            modelValue: _ctx.editCreateTournamentSeasonModal,
            "onUpdate:modelValue": _cache[140] || (_cache[140] = ($event: any) => ((_ctx.editCreateTournamentSeasonModal) = $event)),
            size: "large",
            "hide-default-actions": "",
            "overlay-opacity": "0.5",
            "no-dismiss": ""
          }, {
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_209, [
                _createElementVNode("div", _hoisted_210, [
                  _createVNode(_component_va_button, {
                    class: "btn mr-2",
                    color: "success",
                    onClick: _cache[138] || (_cache[138] = ($event: any) => (_ctx.$refs.createSeasonForm.validate(), (_ctx.validation ? _ctx.createTournamentSeason() : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' }))))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_211
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_va_button, {
                    class: "btn ml-2",
                    color: "secondary",
                    onClick: _cache[139] || (_cache[139] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), _ctx.cancelTournamentSeasonCreateEdit()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_212
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            default: _withCtx(() => [
              _hoisted_202,
              _createVNode(_component_va_card, {
                color: "#afcfff",
                gradient: "",
                stripe: "",
                "stripe-color": "#2f5f4f"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_form, {
                    ref: "createSeasonForm",
                    onValidation: _cache[137] || (_cache[137] = ($event: any) => (_ctx.validation = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_203, [
                        _createElementVNode("div", _hoisted_204, [
                          _createElementVNode("div", _hoisted_205, [
                            _createVNode(_component_va_input, {
                              type: "text",
                              modelValue: _ctx.tournamentSeasonData.seasonName,
                              "onUpdate:modelValue": _cache[133] || (_cache[133] = ($event: any) => ((_ctx.tournamentSeasonData.seasonName) = $event)),
                              label: "Sæsonbetegnelse",
                              placeholder: "Betegnelse",
                              rules: [(v) => v !== '' || 'Sæsonen mangler en betegnelse'],
                              bordered: ""
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _createElementVNode("div", _hoisted_206, [
                            _createVNode(_component_va_input, {
                              class: "center",
                              type: "date",
                              modelValue: _ctx.tournamentSeasonData.seasonRegistrationDate,
                              "onUpdate:modelValue": _cache[134] || (_cache[134] = ($event: any) => ((_ctx.tournamentSeasonData.seasonRegistrationDate) = $event)),
                              label: "Sidste tilmeldingsdato for sæsonen",
                              placeholder: "Dato",
                              rules: [(v) => !!v || 'Der mangler en dato for sidste tilmelding'],
                              bordered: ""
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _createElementVNode("div", _hoisted_207, [
                            _createVNode(_component_va_input, {
                              class: "center",
                              type: "date",
                              modelValue: _ctx.tournamentSeasonData.seasonStartDate,
                              "onUpdate:modelValue": _cache[135] || (_cache[135] = ($event: any) => ((_ctx.tournamentSeasonData.seasonStartDate) = $event)),
                              label: "Sæsonen begynder den",
                              placeholder: "Dato",
                              rules: [(v) => !!v || 'Ingen startdato er angivet'],
                              bordered: ""
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _createElementVNode("div", _hoisted_208, [
                            _createVNode(_component_va_input, {
                              class: "center",
                              type: "date",
                              modelValue: _ctx.tournamentSeasonData.seasonEndDate,
                              "onUpdate:modelValue": _cache[136] || (_cache[136] = ($event: any) => ((_ctx.tournamentSeasonData.seasonEndDate) = $event)),
                              label: "Sæsonen slutter den",
                              placeholder: "Dato",
                              rules: [(v) => !!v || 'Ingen slutdato er angivet'],
                              bordered: ""
                            }, null, 8, ["modelValue", "rules"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_va_modal, {
            modelValue: _ctx.editCreateTournamentSeasonMatchPlanModal,
            "onUpdate:modelValue": _cache[151] || (_cache[151] = ($event: any) => ((_ctx.editCreateTournamentSeasonMatchPlanModal) = $event)),
            size: "large",
            "hide-default-actions": "",
            "overlay-opacity": "0.5",
            "no-dismiss": ""
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_va_button, {
                class: "btn mr-4",
                color: "success",
                onClick: _cache[149] || (_cache[149] = ($event: any) => (_ctx.createTournamentSeasonMatchPlan() ? _ctx.$Message.success({ text: 'Vent venligst, - forslaget til turneringsplanen opbygges nu ...' }) : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' })))
              }, {
                default: _withCtx(() => [
                  _hoisted_232
                ]),
                _: 1
              }),
              _createVNode(_component_va_button, {
                class: "btn ml-4",
                color: "secondary",
                onClick: _cache[150] || (_cache[150] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), _ctx.cancelTournamentSeasonMatchPlanCreateEdit()))
              }, {
                default: _withCtx(() => [
                  _hoisted_233
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_213, [
                _hoisted_214,
                _createElementVNode("div", _hoisted_215, [
                  _createElementVNode("div", _hoisted_216, [
                    _createVNode(_component_va_select, {
                      class: "mr-4",
                      modelValue: _ctx.tournamentSeasonTextValue,
                      "onUpdate:modelValue": _cache[141] || (_cache[141] = ($event: any) => ((_ctx.tournamentSeasonTextValue) = $event)),
                      options: _ctx.tournamentSeasonTextOptions,
                      label: "Vælg sæson",
                      bordered: "",
                      style: {"width":"75%","margin-bottom":"4px"}
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_217, [
                    _createVNode(_component_va_select, {
                      class: "ml-4",
                      modelValue: _ctx.tournamentCategoryTitleValue,
                      "onUpdate:modelValue": _cache[142] || (_cache[142] = ($event: any) => ((_ctx.tournamentCategoryTitleValue) = $event)),
                      options: _ctx.tournamentCategoryTitleOptions,
                      label: "Vælg kategori",
                      bordered: "",
                      style: {"width":"75%","margin-bottom":"4px"}
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_218, [
                  _createElementVNode("div", _hoisted_219, [
                    _createVNode(_component_va_input, {
                      class: "mr-4",
                      type: "number",
                      modelValue: _ctx.matchPlannerData.meetEachTeamTimes,
                      "onUpdate:modelValue": _cache[143] || (_cache[143] = ($event: any) => ((_ctx.matchPlannerData.meetEachTeamTimes) = $event)),
                      label: "Antal møder for hvert hold",
                      placeholder: "Antal",
                      bordered: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_220, [
                    _createVNode(_component_va_input, {
                      class: "ml-4",
                      type: "number",
                      modelValue: _ctx.matchPlannerData.timeBetweenMatches,
                      "onUpdate:modelValue": _cache[144] || (_cache[144] = ($event: any) => ((_ctx.matchPlannerData.timeBetweenMatches) = $event)),
                      label: "Antal timer imellem kampe",
                      placeholder: "Antal",
                      bordered: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_221, [
                  _createElementVNode("div", _hoisted_222, [
                    _createVNode(_component_va_checkbox, {
                      class: "ml-4",
                      modelValue: _ctx.matchPlannerData.matchNumberOfRoundsWithLargestDivisionTeams,
                      "onUpdate:modelValue": _cache[145] || (_cache[145] = ($event: any) => ((_ctx.matchPlannerData.matchNumberOfRoundsWithLargestDivisionTeams) = $event)),
                      label: "Match antal runder med største divisionshold",
                      style: {"margin-top":"8px","margin-bottom":"8px","padding":"8px"}
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_223, [
                  _createElementVNode("div", _hoisted_224, [
                    _createVNode(_component_va_collapse, {
                      modelValue: _ctx.collapseStateValue1,
                      "onUpdate:modelValue": _cache[148] || (_cache[148] = ($event: any) => ((_ctx.collapseStateValue1) = $event)),
                      header: "Avanceret",
                      solid: "",
                      color: "#ffd43a",
                      "color-all": "",
                      "text-color": "#3f8fee",
                      icon: "warning",
                      class: "mb-4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_225, [
                          _createVNode(_component_va_input, {
                            class: "mr-4",
                            type: "number",
                            modelValue: _ctx.matchPlannerData.autoIncreaseNumbTimesTeamsMeetsTreshold,
                            "onUpdate:modelValue": _cache[146] || (_cache[146] = ($event: any) => ((_ctx.matchPlannerData.autoIncreaseNumbTimesTeamsMeetsTreshold) = $event)),
                            label: "Særlig forøgelsestærskel for antallet af kamptræf ved:",
                            placeholder: "Antal hold",
                            bordered: "",
                            style: {"--va-form-element-default-width":"392px"}
                          }, null, 8, ["modelValue"]),
                          _hoisted_226,
                          _hoisted_227,
                          _hoisted_228
                        ]),
                        _createElementVNode("div", _hoisted_229, [
                          _createVNode(_component_va_select, {
                            class: "mr-4",
                            modelValue: _ctx.tournamentMatchScheduleSelectedSlotTextValue,
                            "onUpdate:modelValue": _cache[147] || (_cache[147] = ($event: any) => ((_ctx.tournamentMatchScheduleSelectedSlotTextValue) = $event)),
                            options: _ctx.tournamentMatchScheduleSelectedSlotTextOptions,
                            label: "Opret i slot",
                            bordered: "",
                            style: _normalizeStyle('padding: 8px; margin-bottom: ' + (_ctx.tournamentMatchScheduleSelectedSlotTextOptions.length * 36) + 'px;')
                          }, null, 8, ["modelValue", "options", "style"]),
                          _hoisted_230,
                          _hoisted_231
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_va_modal, {
            modelValue: _ctx.createTournamentSeasonMatchPlanEditModal,
            "onUpdate:modelValue": _cache[155] || (_cache[155] = ($event: any) => ((_ctx.createTournamentSeasonMatchPlanEditModal) = $event)),
            size: "large",
            fixedLayout: true,
            "hide-default-actions": "",
            "overlay-opacity": "0.5",
            "no-dismiss": ""
          }, {
            header: _withCtx(() => [
              _hoisted_234
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_235, [
                _createElementVNode("div", _hoisted_236, [
                  _createVNode(_component_va_pagination, {
                    modelValue: _ctx.currentSelectedTournamentSeasonMatchPlanTeamsTextValueRowIndex,
                    "onUpdate:modelValue": _cache[152] || (_cache[152] = ($event: any) => ((_ctx.currentSelectedTournamentSeasonMatchPlanTeamsTextValueRowIndex) = $event)),
                    pages: (_ctx.tournamentSeasonMatchPlanTeamsTextValue.length),
                    "visible-pages": 7
                  }, null, 8, ["modelValue", "pages"]),
                  _hoisted_237,
                  _createElementVNode("h2", null, [
                    _createElementVNode("p", _hoisted_238, [
                      _createTextVNode("Række: " + _toDisplayString(_ctx.currentSelectedTournamentSeasonMatchPlanTeamsTextValueRowIndex.toString()), 1),
                      _hoisted_239,
                      _createTextVNode(_toDisplayString(_ctx.tournamentSeasonMatchPlanTeamsTextValue[_ctx.currentSelectedTournamentSeasonMatchPlanTeamsTextValueRowIndex - 1].tournamentRow.name), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_240, [
                  _createVNode(_component_va_scroll_container, {
                    vertical: "",
                    color: "primary",
                    style: {"max-height":"480px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_list, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTournamentSeasonMatchPlanTeamsRowsTextValuesMatches(_ctx.currentSelectedTournamentSeasonMatchPlanTeamsTextValueRowIndex - 1), (tournamentSeasonMatchPlanTeamsRowTextValues, index2) => {
                            return (_openBlock(), _createBlock(_component_va_list_item, { key: index2 }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_241, [
                                  (tournamentSeasonMatchPlanTeamsRowTextValues.date !== undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_242, [
                                        _createVNode(_component_va_input, {
                                          class: "mb-4",
                                          type: "datetime-local",
                                          modelValue: tournamentSeasonMatchPlanTeamsRowTextValues.date,
                                          "onUpdate:modelValue": ($event: any) => ((tournamentSeasonMatchPlanTeamsRowTextValues.date) = $event),
                                          label: "Tidspunkt for kamp",
                                          placeholder: "Dato & klokkeslæt",
                                          bordered: "",
                                          style: {"width":"96%","margin-bottom":"4px"}
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_243, "-")),
                                  (tournamentSeasonMatchPlanTeamsRowTextValues.homeTeam !== undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_244, [
                                        _createVNode(_component_va_select, {
                                          class: "ml-4",
                                          modelValue: tournamentSeasonMatchPlanTeamsRowTextValues.homeTeam,
                                          "onUpdate:modelValue": ($event: any) => ((tournamentSeasonMatchPlanTeamsRowTextValues.homeTeam) = $event),
                                          options: _ctx.tournamentSeasonMatchPlanTeamsTextOptions,
                                          label: "Valgt hjemmehold",
                                          searchable: "",
                                          bordered: "",
                                          style: {"width":"96%","margin-bottom":"4px"}
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_245, "-")),
                                  (tournamentSeasonMatchPlanTeamsRowTextValues.guestTeam !== undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_246, [
                                        _createVNode(_component_va_select, {
                                          class: "ml-4",
                                          modelValue: tournamentSeasonMatchPlanTeamsRowTextValues.guestTeam,
                                          "onUpdate:modelValue": ($event: any) => ((tournamentSeasonMatchPlanTeamsRowTextValues.guestTeam) = $event),
                                          options: _ctx.tournamentSeasonMatchPlanTeamsTextOptions,
                                          label: "Valgt udehold",
                                          searchable: "",
                                          bordered: "",
                                          style: {"width":"96%","margin-bottom":"4px"}
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_247, "-"))
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_248, [
                _createElementVNode("div", _hoisted_249, [
                  _createVNode(_component_va_button, {
                    class: "btn mr-2",
                    color: _ctx.actionModeOfSaveTournamentSeasonMatchPlanButton ? 'danger' : 'success',
                    onClick: _cache[153] || (_cache[153] = ($event: any) => (_ctx.saveTournamentSeasonMatchPlan() ? _ctx.$Message.success({ text: 'Oplysningerne gemmes, vent venligst ...' }) : _ctx.$Message.danger({ text: 'Gemningen af oplysninger blev forhindret' })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.actionModeOfSaveTournamentSeasonMatchPlanButton ? 'Stop' : 'Gem'), 1)
                    ]),
                    _: 1
                  }, 8, ["color"]),
                  _createVNode(_component_va_progress_circle, {
                    class: "mb-2",
                    modelValue: _ctx.tournamentMatchPlanNumberOfMatchesSavedProgressValue,
                    color: "#cf11a1",
                    thickness: 0.2,
                    size: 54
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("b", null, _toDisplayString(_ctx.tournamentMatchPlanNumberOfMatchesSavedProgressValue + '%'), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "thickness"]),
                  _createVNode(_component_va_button, {
                    class: "btn mr-2",
                    color: "secondary",
                    onClick: _cache[154] || (_cache[154] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), _ctx.cancelTournamentSeasonMatchPlanCreateEdit())),
                    disabled: _ctx.actionModeOfSaveTournamentSeasonMatchPlanButton
                  }, {
                    default: _withCtx(() => [
                      _hoisted_250
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_251, [
          _hoisted_252,
          _createElementVNode("div", _hoisted_253, [
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.matchColumnName,
              "onUpdate:modelValue": _cache[156] || (_cache[156] = ($event: any) => ((_ctx.matchColumnName) = $event)),
              "array-value": "matchNo",
              label: "Kamp nr."
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.matchColumnName,
              "onUpdate:modelValue": _cache[157] || (_cache[157] = ($event: any) => ((_ctx.matchColumnName) = $event)),
              "array-value": "season",
              label: "Sæson"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.matchColumnName,
              "onUpdate:modelValue": _cache[158] || (_cache[158] = ($event: any) => ((_ctx.matchColumnName) = $event)),
              "array-value": "row",
              label: "Række"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.matchColumnName,
              "onUpdate:modelValue": _cache[159] || (_cache[159] = ($event: any) => ((_ctx.matchColumnName) = $event)),
              "array-value": "homeTeam",
              label: "Hjemmehold"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.matchColumnName,
              "onUpdate:modelValue": _cache[160] || (_cache[160] = ($event: any) => ((_ctx.matchColumnName) = $event)),
              "array-value": "awayTeam",
              label: "Udehold"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.matchColumnName,
              "onUpdate:modelValue": _cache[161] || (_cache[161] = ($event: any) => ((_ctx.matchColumnName) = $event)),
              "array-value": "date",
              label: "Dato"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.matchColumnName,
              "onUpdate:modelValue": _cache[162] || (_cache[162] = ($event: any) => ((_ctx.matchColumnName) = $event)),
              "array-value": "newDate",
              label: "Ny dato"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.matchColumnName,
              "onUpdate:modelValue": _cache[163] || (_cache[163] = ($event: any) => ((_ctx.matchColumnName) = $event)),
              "array-value": "result",
              label: "Resultat"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.matchColumnName,
              "onUpdate:modelValue": _cache[164] || (_cache[164] = ($event: any) => ((_ctx.matchColumnName) = $event)),
              "array-value": "comment",
              label: "Kommentar"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.matchColumnName,
              "onUpdate:modelValue": _cache[165] || (_cache[165] = ($event: any) => ((_ctx.matchColumnName) = $event)),
              "array-value": "match",
              label: "Kampseddel"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_254, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_255, [
              _createElementVNode("table", _hoisted_256, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_257,
                    _withDirectives(_createElementVNode("th", {
                      onClick: _cache[166] || (_cache[166] = ($event: any) => (_ctx.matchColumnSort('matchNo'))),
                      class: "clickAble"
                    }, "Kampnr.", 512), [
                      [_vShow, _ctx.showMatchColumn('matchNo')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      onClick: _cache[167] || (_cache[167] = ($event: any) => (_ctx.matchColumnSort('season'))),
                      class: "clickAble"
                    }, "Sæson", 512), [
                      [_vShow, _ctx.showMatchColumn('season')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      onClick: _cache[168] || (_cache[168] = ($event: any) => (_ctx.matchColumnSort('row'))),
                      class: "clickAble"
                    }, "Turneringsrække", 512), [
                      [_vShow, _ctx.showMatchColumn('row')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      onClick: _cache[169] || (_cache[169] = ($event: any) => (_ctx.matchColumnSort('homeTeam'))),
                      class: "clickAble"
                    }, "Hjemmehold", 512), [
                      [_vShow, _ctx.showMatchColumn('homeTeam')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      onClick: _cache[170] || (_cache[170] = ($event: any) => (_ctx.matchColumnSort('awayTeam'))),
                      class: "clickAble"
                    }, "Udehold", 512), [
                      [_vShow, _ctx.showMatchColumn('awayTeam')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      onClick: _cache[171] || (_cache[171] = ($event: any) => (_ctx.matchColumnSort('date'))),
                      class: "center clickAble"
                    }, "Kampdato", 512), [
                      [_vShow, _ctx.showMatchColumn('date')]
                    ]),
                    _withDirectives(_createElementVNode("th", _hoisted_258, "Ny kampdato", 512), [
                      [_vShow, _ctx.showMatchColumn('newDate')]
                    ]),
                    _withDirectives(_createElementVNode("th", _hoisted_259, "Resultat", 512), [
                      [_vShow, _ctx.showMatchColumn('result')]
                    ]),
                    _withDirectives(_createElementVNode("th", null, "Kommentar", 512), [
                      [_vShow, _ctx.showMatchColumn('comment')]
                    ]),
                    _withDirectives(_createElementVNode("th", null, "Kampseddel", 512), [
                      [_vShow, _ctx.showMatchColumn('match')]
                    ]),
                    _hoisted_260
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kampprograms, (kampprogram, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: kampprogram.id
                  }, [
                    _createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1),
                      hidden: ""
                    }, _toDisplayString(kampprogram.id), 9, _hoisted_261),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1)
                    }, _toDisplayString(kampprogram.kampprogram_kampnr === null ? '-' : kampprogram.kampprogram_kampnr), 9, _hoisted_262), [
                      [_vShow, _ctx.showMatchColumn('matchNo')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1)
                    }, _toDisplayString(kampprogram.saeson_id === null ? '-' : kampprogram?.saeson_id?.saeson_navn), 9, _hoisted_263), [
                      [_vShow, _ctx.showMatchColumn('season')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1)
                    }, _toDisplayString(kampprogram.raekke_id === null ? '-' : kampprogram?.raekke_id?.raekke_navn), 9, _hoisted_264), [
                      [_vShow, _ctx.showMatchColumn('row')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1)
                    }, _toDisplayString(kampprogram.kampprogram_hjemmehold === null ? '-' : kampprogram?.kampprogram_hjemmehold?.hold_holdnavn), 9, _hoisted_265), [
                      [_vShow, _ctx.showMatchColumn('homeTeam')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1)
                    }, _toDisplayString(kampprogram.kampprogram_udehold === null ? '-' : kampprogram?.kampprogram_udehold?.hold_holdnavn), 9, _hoisted_266), [
                      [_vShow, _ctx.showMatchColumn('awayTeam')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(kampprogram.kampprogram_dato === null ? '-' : _ctx.toDanishDateStringWClock(_ctx.locConvertFromUTCtoLocalDateTime(kampprogram?.kampprogram_dato))), 9, _hoisted_267), [
                      [_vShow, _ctx.showMatchColumn('date')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(kampprogram.kampprogram_nydato === null ? '-' : _ctx.toDanishDateStringWClock(_ctx.locConvertFromUTCtoLocalDateTime(kampprogram?.kampprogram_nydato))), 9, _hoisted_268), [
                      [_vShow, _ctx.showMatchColumn('newDate')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(_ctx.getMatchResults(kampprogram.kampprogram_kampnr === null ? 0 : kampprogram?.kampprogram_kampnr)), 9, _hoisted_269), [
                      [_vShow, _ctx.showMatchColumn('result')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1)
                    }, _toDisplayString(kampprogram.kampprogram_kommentar === null ? '-' : _ctx.getTournamentMatchSettlementTeamStatusComment(kampprogram?.kampprogram_afb_udb, kampprogram?.kampprogram_kommentar)), 9, _hoisted_270), [
                      [_vShow, _ctx.showMatchColumn('comment')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1)
                    }, [
                      _createVNode(_component_router_link, {
                        to: ('/turneringer/kampseddel/' + Number(kampprogram?.id).toString())
                      }, {
                        default: _withCtx(() => [
                          _hoisted_272
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ], 8, _hoisted_271), [
                      [_vShow, _ctx.showMatchColumn('match')]
                    ]),
                    _createElementVNode("td", {
                      id: 'tournamentrowstable-row' + (index+1)
                    }, [
                      _createVNode(_component_va_button_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_button, {
                            color: "info",
                            class: "btn",
                            name: "edittournamentmatchschedule",
                            onClick: ($event: any) => (_ctx.editTournamentMatchSchedule(kampprogram.id, kampprogram.raekke_id.raekke_antalspillere, kampprogram.raekke_id.raekke_maxspillere, kampprogram.raekke_id.raekke_antalsaet, (kampprogram.raekke_id.raekke_navn.toLocaleLowerCase().includes('old') && kampprogram.raekke_id.raekke_navn.toLocaleLowerCase().includes('boy'))))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_274
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_va_button, {
                            color: "dark",
                            class: "btn",
                            name: "edittournamentmatchsettlement",
                            onClick: ($event: any) => (_ctx.editTournamentMatchSettlementTeamPlayers(kampprogram.id, kampprogram.kampprogram_kampnr, kampprogram.raekke_id.raekke_antalspillere, kampprogram.raekke_id.raekke_maxspillere, (kampprogram.raekke_id.raekke_navn.toLocaleLowerCase().includes('old') && kampprogram.raekke_id.raekke_navn.toLocaleLowerCase().includes('boy'))))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_275
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_va_button, {
                            color: "dark",
                            class: "btn",
                            name: "edittournamentmatchsettlement",
                            onClick: ($event: any) => (_ctx.editTournamentMatchSettlement(kampprogram.id, kampprogram.raekke_id.raekke_antalspillere, kampprogram.raekke_id.raekke_maxspillere, kampprogram.raekke_id.raekke_antalsaet, (kampprogram.raekke_id.raekke_navn.toLocaleLowerCase().includes('old') && kampprogram.raekke_id.raekke_navn.toLocaleLowerCase().includes('boy'))))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_276
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ], 8, _hoisted_273)
                  ]))
                }), 128))
              ])
            ])),
        _createElementVNode("div", _hoisted_277, [
          _createVNode(_component_va_button, {
            icon: "first_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[172] || (_cache[172] = ($event: any) => (_ctx.jumpToPage3(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[173] || (_cache[173] = ($event: any) => (_ctx.turnToNewPage3(-5)))
          }),
          _createVNode(_component_va_button, {
            icon: "chevron_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[174] || (_cache[174] = ($event: any) => (_ctx.turnToNewPage3(-1)))
          }),
          _hoisted_278,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[175] || (_cache[175] = ($event: any) => ((_ctx.currentPage3) = $event)),
            type: "number",
            onKeyup: _cache[176] || (_cache[176] = _withKeys(($event: any) => (_ctx.jumpToPage3(this.currentPage3)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.currentPage3]
          ]),
          (_ctx.totalNumberOfPages3 === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_279, " af " + _toDisplayString(_ctx.totalNumberOfPages3 + 1), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_280, " af " + _toDisplayString(_ctx.totalNumberOfPages3), 1)),
          _createVNode(_component_va_button, {
            icon: "chevron_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[177] || (_cache[177] = ($event: any) => (_ctx.turnToNewPage3(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[178] || (_cache[178] = ($event: any) => (_ctx.turnToNewPage3(5)))
          }),
          _createVNode(_component_va_button, {
            icon: "last_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[179] || (_cache[179] = ($event: any) => (_ctx.jumpToPage3(this.totalNumberOfPages3)))
          }),
          _hoisted_281,
          _createElementVNode("div", _hoisted_282, [
            _createVNode(_component_va_select, {
              class: "mr-2",
              modelValue: _ctx.pageSizeValueString3,
              "onUpdate:modelValue": _cache[180] || (_cache[180] = ($event: any) => ((_ctx.pageSizeValueString3) = $event)),
              options: _ctx.pageSizeOptions3,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.createNewMatchModal,
          "onUpdate:modelValue": _cache[192] || (_cache[192] = ($event: any) => ((_ctx.createNewMatchModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_294, [
              _createElementVNode("div", _hoisted_295, [
                _createVNode(_component_va_button, {
                  class: "mr-2",
                  color: "success",
                  onClick: _cache[190] || (_cache[190] = ($event: any) => (_ctx.$refs.newMatchForm.validate(), (_ctx.validation ? _ctx.createTournamentMatchSchedule() : _ctx.$Message.danger({ text: 'Et eller flere felter er ikke udfyldt korrekt' }))))
                }, {
                  default: _withCtx(() => [
                    _hoisted_296
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_button, {
                  class: "ml-2",
                  color: "secondary",
                  onClick: _cache[191] || (_cache[191] = ($event: any) => (_ctx.$Message.warning({ text: 'Oprettelsen blev annulleret'}), _ctx.createNewMatchModal = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_297
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_283,
            _createVNode(_component_va_card, {
              color: "#afcfff",
              gradient: "",
              stripe: "",
              "stripe-color": "#2f5f4f"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_form, {
                  ref: "newMatchForm",
                  onValidation: _cache[189] || (_cache[189] = ($event: any) => (_ctx.validation = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_284, [
                      _createElementVNode("div", _hoisted_285, [
                        _createElementVNode("div", _hoisted_286, [
                          _createVNode(_component_va_select, {
                            modelValue: _ctx.tournamentSeasonTextValue,
                            "onUpdate:modelValue": _cache[181] || (_cache[181] = ($event: any) => ((_ctx.tournamentSeasonTextValue) = $event)),
                            options: _ctx.tournamentSeasonTextOptions,
                            searchable: "",
                            bordered: "",
                            label: "Sæson",
                            rules: [(v) => v.value !== '0' || 'Angiv venligst sæson']
                          }, null, 8, ["modelValue", "options", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_287, [
                          _createVNode(_component_va_select, {
                            modelValue: _ctx.tournamentRowsNameValue,
                            "onUpdate:modelValue": _cache[182] || (_cache[182] = ($event: any) => ((_ctx.tournamentRowsNameValue) = $event)),
                            options: _ctx.tournamentRowsNameOptions,
                            searchable: "",
                            bordered: "",
                            label: "Række",
                            rules: [(v) => v.value !== '0' || 'Angiv venligst en række']
                          }, null, 8, ["modelValue", "options", "rules"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_288, [
                        _createElementVNode("div", _hoisted_289, [
                          _createVNode(_component_va_select, {
                            label: "Hjemmehold",
                            modelValue: _ctx.homeTeamNameValue,
                            "onUpdate:modelValue": _cache[183] || (_cache[183] = ($event: any) => ((_ctx.homeTeamNameValue) = $event)),
                            options: _ctx.homeTeamNameOptions,
                            onClick: _cache[184] || (_cache[184] = ($event: any) => (_ctx.templateGetTeams($event, false, 'hjhold'))),
                            bordered: "",
                            searchable: "",
                            rules: [(v) => v.value !== '0' || 'Hjemmeholdet er ikke sat']
                          }, null, 8, ["modelValue", "options", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_290, [
                          _createVNode(_component_va_select, {
                            label: "Udehold",
                            modelValue: _ctx.guestTeamNameValue,
                            "onUpdate:modelValue": _cache[185] || (_cache[185] = ($event: any) => ((_ctx.guestTeamNameValue) = $event)),
                            options: _ctx.guestTeamNameOptions,
                            onClick: _cache[186] || (_cache[186] = ($event: any) => (_ctx.templateGetTeams($event, false, 'udhold'))),
                            bordered: "",
                            searchable: "",
                            rules: [(v) => v.value !== '0' || 'Udeholdet er ikke sat']
                          }, null, 8, ["modelValue", "options", "rules"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_291, [
                        _createElementVNode("div", _hoisted_292, [
                          _createVNode(_component_va_input, {
                            modelValue: _ctx.tournamentMatchScheduleData.matchScheduleDate,
                            "onUpdate:modelValue": _cache[187] || (_cache[187] = ($event: any) => ((_ctx.tournamentMatchScheduleData.matchScheduleDate) = $event)),
                            type: "datetime-local",
                            bordered: "",
                            label: "Kampdato",
                            rules: [(v) => !!v || 'Dato for kampen er ikke angivet']
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_293, [
                          _createVNode(_component_va_input, {
                            modelValue: _ctx.tournamentMatchScheduleData.matchScheduleComment,
                            "onUpdate:modelValue": _cache[188] || (_cache[188] = ($event: any) => ((_ctx.tournamentMatchScheduleData.matchScheduleComment) = $event)),
                            label: "Kommentar",
                            bordered: "",
                            type: "textarea",
                            rows: 7
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editTournamentMatchScheduleModal,
          "onUpdate:modelValue": _cache[204] || (_cache[204] = ($event: any) => ((_ctx.editTournamentMatchScheduleModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_308, [
              _createElementVNode("div", _hoisted_309, [
                _createVNode(_component_va_button, {
                  class: "btn mr-2",
                  color: "success",
                  onClick: _cache[202] || (_cache[202] = ($event: any) => (_ctx.$refs.editMatchScheduleForm.validate(), (_ctx.validation ? _ctx.updateTournamentMatchSchedule() : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' }))))
                }, {
                  default: _withCtx(() => [
                    _hoisted_310
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_button, {
                  class: "btn ml-2",
                  color: "secondary",
                  onClick: _cache[203] || (_cache[203] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), _ctx.cancelTournamentMatchScheduleEdit()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_311
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_298, "Rediger kampoplysninger for kamp nr. " + _toDisplayString(_ctx.tournamentMatchScheduleData.matchNumber), 1),
            _createVNode(_component_va_card, {
              color: "#afcfff",
              gradient: "",
              "stripe-color": "#2f5f4f"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_form, {
                  ref: "editMatchScheduleForm",
                  onValidation: _cache[201] || (_cache[201] = ($event: any) => (_ctx.validation = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_299, [
                      _createElementVNode("div", _hoisted_300, [
                        _createElementVNode("div", _hoisted_301, [
                          _createVNode(_component_va_input, {
                            class: "center",
                            type: "datetime-local",
                            modelValue: _ctx.tournamentMatchScheduleData.matchScheduleDate,
                            "onUpdate:modelValue": _cache[194] || (_cache[194] = ($event: any) => ((_ctx.tournamentMatchScheduleData.matchScheduleDate) = $event)),
                            label: "Kampdato fastsat ved oprettelsen *",
                            placeholder: "Dato",
                            bordered: "",
                            readonly: _ctx.matchScheduleDateLockFlag
                          }, {
                            appendInner: _withCtx(() => [
                              _createVNode(_component_va_icon, {
                                name: (_ctx.matchScheduleDateLockFlag ? 'lock' : 'lock_open'),
                                onClick: _cache[193] || (_cache[193] = ($event: any) => (_ctx.matchScheduleDateLockFlag = !_ctx.matchScheduleDateLockFlag))
                              }, null, 8, ["name"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "readonly"])
                        ]),
                        _createElementVNode("div", _hoisted_302, [
                          _createVNode(_component_va_input, {
                            class: "center",
                            type: "datetime-local",
                            modelValue: _ctx.tournamentMatchScheduleData.matchScheduleDateNewDate,
                            "onUpdate:modelValue": _cache[195] || (_cache[195] = ($event: any) => ((_ctx.tournamentMatchScheduleData.matchScheduleDateNewDate) = $event)),
                            label: "Ny kampdato",
                            placeholder: "Dato",
                            bordered: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_303, [
                          _createVNode(_component_va_select, {
                            label: "Hjemmehold",
                            modelValue: _ctx.homeTeamNameValue,
                            "onUpdate:modelValue": _cache[196] || (_cache[196] = ($event: any) => ((_ctx.homeTeamNameValue) = $event)),
                            options: _ctx.homeTeamNameOptions,
                            rules: [(v) => v.value !== '0' || 'Hjemmeholdet er ikke angivet' ],
                            searchable: "",
                            bordered: ""
                          }, null, 8, ["modelValue", "options", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_304, [
                          _createVNode(_component_va_select, {
                            label: "Udehold",
                            modelValue: _ctx.guestTeamNameValue,
                            "onUpdate:modelValue": _cache[197] || (_cache[197] = ($event: any) => ((_ctx.guestTeamNameValue) = $event)),
                            options: _ctx.guestTeamNameOptions,
                            rules: [(v) => v.value !== '0' || 'Udeholdet er ikke angivet'],
                            searchable: "",
                            bordered: ""
                          }, null, 8, ["modelValue", "options", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_305, [
                          _createVNode(_component_va_option_list, {
                            type: "radio",
                            label: "Kommentarstatus",
                            options: ['Ingen', 'Protest fra hjemmeholdet', 'Protest fra udeholdet', 'Afbud fra hjemmeholdet', 'Afbud fra udeholdet', 'Udeblivelse af hjemmeholdet', 'Udeblivelse af udeholdet'],
                            modelValue: _ctx.tournamentMatchSettlementTeamProtestStatusValue,
                            "onUpdate:modelValue": _cache[198] || (_cache[198] = ($event: any) => ((_ctx.tournamentMatchSettlementTeamProtestStatusValue) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_306, [
                          _createVNode(_component_va_input, {
                            class: "matchScheduleTextarea",
                            type: "textarea",
                            modelValue: _ctx.tournamentMatchScheduleData.matchScheduleComment,
                            "onUpdate:modelValue": _cache[199] || (_cache[199] = ($event: any) => ((_ctx.tournamentMatchScheduleData.matchScheduleComment) = $event)),
                            label: "Kommentar",
                            placeholder: "Tekst",
                            rows: 10,
                            bordered: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_307, [
                          _createVNode(_component_va_checkbox, {
                            modelValue: _ctx.matchFinalApproval.new,
                            "onUpdate:modelValue": _cache[200] || (_cache[200] = ($event: any) => ((_ctx.matchFinalApproval.new) = $event)),
                            label: "Kampseddel er godkendt"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editTournamentMatchSettlementModal,
          "onUpdate:modelValue": _cache[211] || (_cache[211] = ($event: any) => ((_ctx.editTournamentMatchSettlementModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "mobile-fullscreen": "",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[208] || (_cache[208] = ($event: any) => (_ctx.updateTournamentSettlementMatchSetTables() ? _ctx.$Message.success({ text: 'Opdateret' }) : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' })))
            }, {
              default: _withCtx(() => [
                _hoisted_392
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "info",
              name: "edittournamentmatchsettlementteamproteststatus",
              onClick: _cache[209] || (_cache[209] = ($event: any) => (_ctx.editTournamentMatchSettlementTeamProtestStatus()))
            }, {
              default: _withCtx(() => [
                _hoisted_393
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[210] || (_cache[210] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev lukket' }), _ctx.cancelTournamentMatchSettlementEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_394
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_312, [
              _hoisted_313,
              _createElementVNode("div", _hoisted_314, [
                _createElementVNode("div", _hoisted_315, [
                  _createVNode(_component_va_switch, {
                    modelValue: _ctx.matchAutoUpdateMode,
                    "onUpdate:modelValue": _cache[205] || (_cache[205] = ($event: any) => ((_ctx.matchAutoUpdateMode) = $event)),
                    label: "Automatisk opdatering",
                    "true-inner-label": "Aktiv",
                    "false-inner-label": "Inaktiv",
                    class: "mr-4"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_316, [
                _createElementVNode("table", _hoisted_317, [
                  _hoisted_318,
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_319, "Kamp-nr. " + _toDisplayString(_ctx.tournamentMatchScheduleData.matchNumber), 1),
                    _createElementVNode("td", _hoisted_320, "Række " + _toDisplayString(_ctx.tournamentMatchScheduleData.matchTournamentRow.name), 1),
                    _hoisted_321
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_322, "Kampdato " + _toDisplayString((_ctx.tournamentMatchScheduleData.matchScheduleDateNewDate === null || _ctx.tournamentMatchScheduleData.matchScheduleDateNewDate.trim().startsWith('1970-01-01T') ? (new Date(_ctx.tournamentMatchScheduleData.matchScheduleDate)).toLocaleDateString('da-DK', { day: '2-digit', month: 'long', year: 'numeric' }) : (new Date(_ctx.tournamentMatchScheduleData.matchScheduleDateNewDate)).toLocaleDateString('da-DK', { day: '2-digit', month: 'long', year: 'numeric' }))), 1),
                    _createElementVNode("td", _hoisted_323, "Hjemmehold " + _toDisplayString(_ctx.tournamentMatchScheduleData.matchHomeTeamName), 1),
                    _createElementVNode("td", _hoisted_324, "Total resultat: " + _toDisplayString(_ctx.tournamentMatchScheduleData.matchHomeTeamResult), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_325, "Start " + _toDisplayString((_ctx.tournamentMatchScheduleData.matchScheduleDateNewDate === null || _ctx.tournamentMatchScheduleData.matchScheduleDateNewDate.trim().startsWith('1970-01-01T') ? (new Date(_ctx.tournamentMatchScheduleData.matchScheduleDate)).toLocaleTimeString().replaceAll('.', ':') : (new Date(_ctx.tournamentMatchScheduleData.matchScheduleDateNewDate)).toLocaleTimeString().replaceAll('.', ':'))), 1),
                    _createElementVNode("td", _hoisted_326, "Udehold " + _toDisplayString(_ctx.tournamentMatchScheduleData.matchGuestTeamName), 1),
                    _createElementVNode("td", _hoisted_327, "Total resultat: " + _toDisplayString(_ctx.tournamentMatchScheduleData.matchGuestTeamResult), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_328, "Hjemmehold kaptajn: " + _toDisplayString(_ctx.teamCaptain.homeTeamCaptain ? _ctx.teamCaptain.homeTeamCaptain.firstname + ' ' + _ctx.teamCaptain.homeTeamCaptain.lastname : '-'), 1),
                    _createElementVNode("td", _hoisted_329, "Udehold kaptajn: " + _toDisplayString(_ctx.teamCaptain.awayTeamCaptain ? _ctx.teamCaptain.awayTeamCaptain.firstname + ' ' + _ctx.teamCaptain.awayTeamCaptain.lastname : '-'), 1),
                    _hoisted_330
                  ])
                ])
              ]),
              _hoisted_331,
              _createElementVNode("h3", null, [
                _createElementVNode("div", _hoisted_332, [
                  _createElementVNode("div", _hoisted_333, _toDisplayString(_ctx.tournamentMatchScheduleData.matchHomeTeamName), 1),
                  _createElementVNode("div", _hoisted_334, [
                    _createVNode(_component_va_rating, {
                      modelValue: _ctx.tournamentMatchScheduleData.matchHomeTeamVerdict,
                      "onUpdate:modelValue": _cache[206] || (_cache[206] = ($event: any) => ((_ctx.tournamentMatchScheduleData.matchHomeTeamVerdict) = $event)),
                      icon: "thumb_down_alt",
                      "half-icon": "thumbs_up_down",
                      "empty-icon": "thumb_up_alt",
                      max: 1,
                      halves: "",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_335, [
                _createElementVNode("table", _hoisted_336, [
                  _hoisted_337,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tournamentMatchScheduleHomeTeamPlayersInfoData.filter( item => (item.hide === false) ), (tournamentMatchScheduleHomeTeamPlayerInfoData, hometeamplayerindex) => {
                    return (_openBlock(), _createElementBlock("tr", { key: hometeamplayerindex }, [
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (hometeamplayerindex + 1)
                      }, _toDisplayString(hometeamplayerindex + 1) + " " + _toDisplayString(tournamentMatchScheduleHomeTeamPlayerInfoData.playerName), 9, _hoisted_338),
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (hometeamplayerindex + 1)
                      }, [
                        _createVNode(_component_va_rating, {
                          modelValue: tournamentMatchScheduleHomeTeamPlayerInfoData.playerVerdict,
                          "onUpdate:modelValue": ($event: any) => (tournamentMatchScheduleHomeTeamPlayerInfoData.playerVerdict = $event, _ctx.setMatchTeamPlayerVerdictDirtyFlag(tournamentMatchScheduleHomeTeamPlayerInfoData.playerMemberId)),
                          icon: "thumb_down_alt",
                          "half-icon": "thumbs_up_down",
                          "empty-icon": "thumb_up_alt",
                          max: 1,
                          halves: "",
                          clearable: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ], 8, _hoisted_339),
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (hometeamplayerindex + 1)
                      }, _toDisplayString(tournamentMatchScheduleHomeTeamPlayerInfoData.playerLicense), 9, _hoisted_340),
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (hometeamplayerindex + 1)
                      }, _toDisplayString(tournamentMatchScheduleHomeTeamPlayerInfoData.matchesWon), 9, _hoisted_341),
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (hometeamplayerindex + 1)
                      }, _toDisplayString(tournamentMatchScheduleHomeTeamPlayerInfoData.matchSetsWon), 9, _hoisted_342),
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (hometeamplayerindex + 1)
                      }, _toDisplayString(tournamentMatchScheduleHomeTeamPlayerInfoData.matchSetsLost), 9, _hoisted_343),
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (hometeamplayerindex + 1)
                      }, [
                        _createVNode(_component_va_input, {
                          class: "mb-3",
                          type: "number",
                          modelValue: tournamentMatchScheduleHomeTeamPlayerInfoData.match180,
                          "onUpdate:modelValue": ($event: any) => ((tournamentMatchScheduleHomeTeamPlayerInfoData.match180) = $event),
                          error: tournamentMatchScheduleHomeTeamPlayerInfoData.match180 < 0,
                          "error-messages": "Værdien er ugyldigt",
                          label: "",
                          placeholder: "#",
                          bordered: "",
                          style: {"width":"96px"}
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "error"])
                      ], 8, _hoisted_344),
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (hometeamplayerindex + 1)
                      }, _toDisplayString(tournamentMatchScheduleHomeTeamPlayerInfoData.matchSetHighestClosing), 9, _hoisted_345),
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (hometeamplayerindex + 1)
                      }, _toDisplayString(tournamentMatchScheduleHomeTeamPlayerInfoData.matchSetFastestDarting), 9, _hoisted_346)
                    ]))
                  }), 128))
                ])
              ]),
              _hoisted_347,
              _createElementVNode("h3", null, [
                _createElementVNode("div", _hoisted_348, [
                  _createElementVNode("div", _hoisted_349, _toDisplayString(_ctx.tournamentMatchScheduleData.matchGuestTeamName), 1),
                  _createElementVNode("div", _hoisted_350, [
                    _createVNode(_component_va_rating, {
                      modelValue: _ctx.tournamentMatchScheduleData.matchGuestTeamVerdict,
                      "onUpdate:modelValue": _cache[207] || (_cache[207] = ($event: any) => ((_ctx.tournamentMatchScheduleData.matchGuestTeamVerdict) = $event)),
                      icon: "thumb_down_alt",
                      "half-icon": "thumbs_up_down",
                      "empty-icon": "thumb_up_alt",
                      max: 1,
                      halves: "",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_351, [
                _createElementVNode("table", _hoisted_352, [
                  _hoisted_353,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tournamentMatchScheduleGuestTeamPlayersInfoData.filter( item => (item.hide === false) ), (tournamentMatchScheduleGuestTeamPlayerInfoData, guestteamplayerindex) => {
                    return (_openBlock(), _createElementBlock("tr", { key: guestteamplayerindex }, [
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (guestteamplayerindex + 1)
                      }, _toDisplayString(String.fromCharCode(guestteamplayerindex + 65)) + " " + _toDisplayString(tournamentMatchScheduleGuestTeamPlayerInfoData.playerName), 9, _hoisted_354),
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (guestteamplayerindex + 1)
                      }, [
                        _createVNode(_component_va_rating, {
                          modelValue: tournamentMatchScheduleGuestTeamPlayerInfoData.playerVerdict,
                          "onUpdate:modelValue": ($event: any) => (tournamentMatchScheduleGuestTeamPlayerInfoData.playerVerdict = $event, _ctx.setMatchTeamPlayerVerdictDirtyFlag(tournamentMatchScheduleGuestTeamPlayerInfoData.playerMemberId, false)),
                          icon: "thumb_down_alt",
                          "half-icon": "thumbs_up_down",
                          "empty-icon": "thumb_up_alt",
                          max: 1,
                          halves: "",
                          clearable: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ], 8, _hoisted_355),
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (guestteamplayerindex + 1)
                      }, _toDisplayString(tournamentMatchScheduleGuestTeamPlayerInfoData.playerLicense), 9, _hoisted_356),
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (guestteamplayerindex + 1)
                      }, _toDisplayString(tournamentMatchScheduleGuestTeamPlayerInfoData.matchesWon), 9, _hoisted_357),
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (guestteamplayerindex + 1)
                      }, _toDisplayString(tournamentMatchScheduleGuestTeamPlayerInfoData.matchSetsWon), 9, _hoisted_358),
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (guestteamplayerindex + 1)
                      }, _toDisplayString(tournamentMatchScheduleGuestTeamPlayerInfoData.matchSetsLost), 9, _hoisted_359),
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (guestteamplayerindex + 1)
                      }, [
                        _createVNode(_component_va_input, {
                          class: "mb-3",
                          type: "number",
                          modelValue: tournamentMatchScheduleGuestTeamPlayerInfoData.match180,
                          "onUpdate:modelValue": ($event: any) => ((tournamentMatchScheduleGuestTeamPlayerInfoData.match180) = $event),
                          error: tournamentMatchScheduleGuestTeamPlayerInfoData.match180 < 0,
                          "error-messages": "Værdien er ugyldigt",
                          label: "",
                          placeholder: "#",
                          bordered: "",
                          style: {"width":"96px"}
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "error"])
                      ], 8, _hoisted_360),
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (guestteamplayerindex + 1)
                      }, _toDisplayString(tournamentMatchScheduleGuestTeamPlayerInfoData.matchSetHighestClosing), 9, _hoisted_361),
                      _createElementVNode("td", {
                        id: 'tournamentmatchsettlementplayerinfotable-row' + (guestteamplayerindex + 1)
                      }, _toDisplayString(tournamentMatchScheduleGuestTeamPlayerInfoData.matchSetFastestDarting), 9, _hoisted_362)
                    ]))
                  }), 128))
                ])
              ]),
              _hoisted_363,
              (_ctx.matchSettlementNumberOfPresentMatchesCreated === _ctx.matchSettlementNumberOfMatches && _ctx.matchSettlementNumberOfPresentMatchesSetsCreated === _ctx.matchSettlementNumberOfSetsPerMatch * _ctx.matchSettlementNumberOfMatches)
                ? (_openBlock(), _createElementBlock("div", _hoisted_364, [
                    _createElementVNode("table", _hoisted_365, [
                      _hoisted_366,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTournamentMatchPlayersRowsData(), (tournamentMatchSettlementDataRow, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", {
                              id: 'tournamentmatchsettlementtable-row' + (index + 1)
                            }, _toDisplayString((index + 1)) + " [" + _toDisplayString((tournamentMatchSettlementDataRow.matchRealIndexNumber + 1)) + "]", 9, _hoisted_367),
                            (tournamentMatchSettlementDataRow.matchHomeTeamPlayer === undefined || tournamentMatchSettlementDataRow.matchHomeTeamPlayer === null || tournamentMatchSettlementDataRow.matchHomeTeamPlayer2 === undefined || tournamentMatchSettlementDataRow.matchHomeTeamPlayer2 === null)
                              ? (_openBlock(), _createElementBlock("td", {
                                  key: 0,
                                  id: 'tournamentmatchsettlementtable-row' + (index + 1)
                                }, "-", 8, _hoisted_368))
                              : (_openBlock(), _createElementBlock("td", {
                                  key: 1,
                                  id: 'tournamentmatchsettlementtable-row' + (index + 1)
                                }, [
                                  _createTextVNode(_toDisplayString((tournamentMatchSettlementDataRow.matchHomeTeamPlayer === '9' ? '' : tournamentMatchSettlementDataRow.matchHomeTeamPlayer + ' ' + tournamentMatchSettlementDataRow.matchHomeTeamPlayerName)), 1),
                                  _hoisted_370,
                                  _createTextVNode(_toDisplayString((tournamentMatchSettlementDataRow.matchHomeTeamPlayer2 === '9' ? '' : tournamentMatchSettlementDataRow.matchHomeTeamPlayer2 + ' ' + tournamentMatchSettlementDataRow.matchHomeTeamPlayer2Name)), 1),
                                  _hoisted_371,
                                  _createTextVNode(_toDisplayString((tournamentMatchSettlementDataRow.matchHomeScoreResultRecorder === null ? '' : (tournamentMatchSettlementDataRow.matchHomeScoreResultRecorder === '0' ? '* Udlæg & tavlefører' : '* (' + tournamentMatchSettlementDataRow.matchHomeScoreResultRecorder + ')'))), 1)
                                ], 8, _hoisted_369)),
                            (_ctx.matchSettlementNumberOfPresentMatchesSetsCreated !== _ctx.matchSettlementNumberOfSetsPerMatch * _ctx.matchSettlementNumberOfMatches)
                              ? (_openBlock(), _createElementBlock("td", {
                                  key: 2,
                                  id: 'tournamentmatchsettlementtable-row' + (index + 1)
                                }, "-", 8, _hoisted_372))
                              : (_openBlock(), _createElementBlock("td", {
                                  key: 3,
                                  id: 'tournamentmatchsettlementtable-row' + (index + 1)
                                }, [
                                  _createElementVNode("div", _hoisted_374, [
                                    _createElementVNode("table", _hoisted_375, [
                                      _hoisted_376,
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTournamentMatchSettlementPlayerMatchSetResultThroughIndex((tournamentMatchSettlementDataRow.matchRealIndexNumber + 1)), (tournamentSettlementMatchSetDataRow, index2) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: tournamentSettlementMatchSetDataRow.matchSet
                                          }, [
                                            (tournamentSettlementMatchSetDataRow.matchIndexNumber === (tournamentMatchSettlementDataRow.matchRealIndexNumber + 1) && tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam)
                                              ? (_openBlock(), _createElementBlock("td", {
                                                  key: 0,
                                                  id: 'tournamentmatchsettlementsettable-row-rt' + (index2 + 1)
                                                }, [
                                                  _createVNode(_component_va_input, {
                                                    class: "mb-4",
                                                    type: "number",
                                                    modelValue: tournamentSettlementMatchSetDataRow.matchSetRemainScore,
                                                    "onUpdate:modelValue": ($event: any) => ((tournamentSettlementMatchSetDataRow.matchSetRemainScore) = $event),
                                                    onChange: ($event: any) => (_ctx.updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult(tournamentSettlementMatchSetDataRow.matchIndexNumber, tournamentSettlementMatchSetDataRow.matchSet, tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam, true, tournamentSettlementMatchSetDataRow.matchSetDart, tournamentSettlementMatchSetDataRow.matchSetClosed, tournamentSettlementMatchSetDataRow.matchSetRemainScore)),
                                                    onKeyup: _withKeys(($event: any) => (_ctx.updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult(tournamentSettlementMatchSetDataRow.matchIndexNumber, tournamentSettlementMatchSetDataRow.matchSet, tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam, true, tournamentSettlementMatchSetDataRow.matchSetDart, tournamentSettlementMatchSetDataRow.matchSetClosed, tournamentSettlementMatchSetDataRow.matchSetRemainScore)), ["enter"]),
                                                    error: (tournamentSettlementMatchSetDataRow.matchSetDirtyFlag & 8) === 8,
                                                    "error-messages": "Værdien er ugyldigt",
                                                    label: "",
                                                    placeholder: "#",
                                                    disabled: (tournamentMatchSettlementDataRow.matchHomeTeamPlayer === undefined || tournamentMatchSettlementDataRow.matchHomeTeamPlayer === null || tournamentMatchSettlementDataRow.matchHomeTeamPlayer === '9' || (tournamentMatchSettlementDataRow.matchIsDouble && (tournamentMatchSettlementDataRow.matchHomeTeamPlayer2 === undefined || tournamentMatchSettlementDataRow.matchHomeTeamPlayer2 === null || tournamentMatchSettlementDataRow.matchHomeTeamPlayer2 === '9')) || (!tournamentMatchSettlementDataRow.matchIsDouble && (tournamentMatchSettlementDataRow.matchGuestTeamPlayer === undefined || tournamentMatchSettlementDataRow.matchGuestTeamPlayer === null || tournamentMatchSettlementDataRow.matchGuestTeamPlayer === 'Z'))),
                                                    bordered: ""
                                                  }, {
                                                    appendInner: _withCtx(() => [
                                                      ((tournamentSettlementMatchSetDataRow.matchSetDirtyFlag & 4) === 4)
                                                        ? (_openBlock(), _createBlock(_component_va_icon, {
                                                            key: 0,
                                                            name: "loop",
                                                            spin: "counter-clockwise",
                                                            class: "mr-2"
                                                          }))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "onKeyup", "error", "disabled"])
                                                ], 8, _hoisted_377))
                                              : _createCommentVNode("", true),
                                            (tournamentSettlementMatchSetDataRow.matchIndexNumber === (tournamentMatchSettlementDataRow.matchRealIndexNumber + 1) && tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam)
                                              ? (_openBlock(), _createElementBlock("td", {
                                                  key: 1,
                                                  id: 'tournamentmatchsettlementsettable-row-rt' + (index2 + 1)
                                                }, [
                                                  _createVNode(_component_va_input, {
                                                    class: "mb-4",
                                                    type: "number",
                                                    modelValue: tournamentSettlementMatchSetDataRow.matchSetDart,
                                                    "onUpdate:modelValue": ($event: any) => ((tournamentSettlementMatchSetDataRow.matchSetDart) = $event),
                                                    onChange: ($event: any) => (_ctx.updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult(tournamentSettlementMatchSetDataRow.matchIndexNumber, tournamentSettlementMatchSetDataRow.matchSet, tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam, true, tournamentSettlementMatchSetDataRow.matchSetDart, tournamentSettlementMatchSetDataRow.matchSetClosed, tournamentSettlementMatchSetDataRow.matchSetRemainScore)),
                                                    onKeyup: _withKeys(($event: any) => (_ctx.updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult(tournamentSettlementMatchSetDataRow.matchIndexNumber, tournamentSettlementMatchSetDataRow.matchSet, tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam, true, tournamentSettlementMatchSetDataRow.matchSetDart, tournamentSettlementMatchSetDataRow.matchSetClosed, tournamentSettlementMatchSetDataRow.matchSetRemainScore)), ["enter"]),
                                                    error: (tournamentSettlementMatchSetDataRow.matchSetDirtyFlag & 1) === 1,
                                                    "error-messages": "Værdien er ugyldigt",
                                                    label: "",
                                                    placeholder: "#",
                                                    disabled: (tournamentMatchSettlementDataRow.matchHomeTeamPlayer === undefined || tournamentMatchSettlementDataRow.matchHomeTeamPlayer === null || tournamentMatchSettlementDataRow.matchHomeTeamPlayer === '9' || (tournamentMatchSettlementDataRow.matchIsDouble && (tournamentMatchSettlementDataRow.matchHomeTeamPlayer2 === undefined || tournamentMatchSettlementDataRow.matchHomeTeamPlayer2 === null || tournamentMatchSettlementDataRow.matchHomeTeamPlayer2 === '9')) || (!tournamentMatchSettlementDataRow.matchIsDouble && (tournamentMatchSettlementDataRow.matchGuestTeamPlayer === undefined || tournamentMatchSettlementDataRow.matchGuestTeamPlayer === null || tournamentMatchSettlementDataRow.matchGuestTeamPlayer === 'Z'))),
                                                    bordered: ""
                                                  }, {
                                                    appendInner: _withCtx(() => [
                                                      ((tournamentSettlementMatchSetDataRow.matchSetDirtyFlag & 4) === 4)
                                                        ? (_openBlock(), _createBlock(_component_va_icon, {
                                                            key: 0,
                                                            name: "loop",
                                                            spin: "counter-clockwise",
                                                            class: "mr-2"
                                                          }))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "onKeyup", "error", "disabled"])
                                                ], 8, _hoisted_378))
                                              : _createCommentVNode("", true),
                                            (tournamentSettlementMatchSetDataRow.matchIndexNumber === (tournamentMatchSettlementDataRow.matchRealIndexNumber + 1) && tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam)
                                              ? (_openBlock(), _createElementBlock("td", {
                                                  key: 2,
                                                  id: 'tournamentmatchsettlementsettable-row-rt' + (index2 + 1)
                                                }, [
                                                  _createVNode(_component_va_input, {
                                                    class: "mb-4",
                                                    type: "number",
                                                    modelValue: tournamentSettlementMatchSetDataRow.matchSetClosed,
                                                    "onUpdate:modelValue": ($event: any) => ((tournamentSettlementMatchSetDataRow.matchSetClosed) = $event),
                                                    onChange: ($event: any) => (_ctx.updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult(tournamentSettlementMatchSetDataRow.matchIndexNumber, tournamentSettlementMatchSetDataRow.matchSet, tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam, true, tournamentSettlementMatchSetDataRow.matchSetDart, tournamentSettlementMatchSetDataRow.matchSetClosed, tournamentSettlementMatchSetDataRow.matchSetRemainScore)),
                                                    onKeyup: _withKeys(($event: any) => (_ctx.updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult(tournamentSettlementMatchSetDataRow.matchIndexNumber, tournamentSettlementMatchSetDataRow.matchSet, tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam, true, tournamentSettlementMatchSetDataRow.matchSetDart, tournamentSettlementMatchSetDataRow.matchSetClosed, tournamentSettlementMatchSetDataRow.matchSetRemainScore)), ["enter"]),
                                                    error: (tournamentSettlementMatchSetDataRow.matchSetDirtyFlag & 2) === 2,
                                                    "error-messages": "Værdien er ugyldigt",
                                                    label: "",
                                                    placeholder: "#",
                                                    disabled: (tournamentMatchSettlementDataRow.matchHomeTeamPlayer === undefined || tournamentMatchSettlementDataRow.matchHomeTeamPlayer === null || tournamentMatchSettlementDataRow.matchHomeTeamPlayer === '9' || (tournamentMatchSettlementDataRow.matchIsDouble && (tournamentMatchSettlementDataRow.matchHomeTeamPlayer2 === undefined || tournamentMatchSettlementDataRow.matchHomeTeamPlayer2 === null || tournamentMatchSettlementDataRow.matchHomeTeamPlayer2 === '9')) || (!tournamentMatchSettlementDataRow.matchIsDouble && (tournamentMatchSettlementDataRow.matchGuestTeamPlayer === undefined || tournamentMatchSettlementDataRow.matchGuestTeamPlayer === null || tournamentMatchSettlementDataRow.matchGuestTeamPlayer === 'Z'))),
                                                    bordered: ""
                                                  }, {
                                                    appendInner: _withCtx(() => [
                                                      ((tournamentSettlementMatchSetDataRow.matchSetDirtyFlag & 4) === 4)
                                                        ? (_openBlock(), _createBlock(_component_va_icon, {
                                                            key: 0,
                                                            name: "loop",
                                                            spin: "counter-clockwise",
                                                            class: "mr-2"
                                                          }))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "onKeyup", "error", "disabled"])
                                                ], 8, _hoisted_379))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ])
                                ], 8, _hoisted_373)),
                            (_ctx.matchSettlementNumberOfPresentMatchesSetsCreated !== _ctx.matchSettlementNumberOfSetsPerMatch * _ctx.matchSettlementNumberOfMatches)
                              ? (_openBlock(), _createElementBlock("td", {
                                  key: 4,
                                  id: 'tournamentmatchsettlementtable-row' + (index + 1)
                                }, "-", 8, _hoisted_380))
                              : (_openBlock(), _createElementBlock("td", {
                                  key: 5,
                                  id: 'tournamentmatchsettlementtable-row' + (index + 1)
                                }, [
                                  _createElementVNode("div", _hoisted_382, [
                                    _createElementVNode("table", _hoisted_383, [
                                      _hoisted_384,
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTournamentMatchSettlementPlayerMatchSetResultThroughIndex((tournamentMatchSettlementDataRow.matchRealIndexNumber + 1)), (tournamentSettlementMatchSetDataRow, index2) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: tournamentSettlementMatchSetDataRow.matchSet
                                          }, [
                                            (tournamentSettlementMatchSetDataRow.matchIndexNumber === (tournamentMatchSettlementDataRow.matchRealIndexNumber + 1) && tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam === false)
                                              ? (_openBlock(), _createElementBlock("td", {
                                                  key: 0,
                                                  id: 'tournamentmatchsettlementsettable-row-lt' + (index2 + 1)
                                                }, [
                                                  _createVNode(_component_va_input, {
                                                    class: "mb-4",
                                                    type: "number",
                                                    modelValue: tournamentSettlementMatchSetDataRow.matchSetClosed,
                                                    "onUpdate:modelValue": ($event: any) => ((tournamentSettlementMatchSetDataRow.matchSetClosed) = $event),
                                                    onChange: ($event: any) => (_ctx.updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult(tournamentSettlementMatchSetDataRow.matchIndexNumber, tournamentSettlementMatchSetDataRow.matchSet, tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam, true, tournamentSettlementMatchSetDataRow.matchSetDart, tournamentSettlementMatchSetDataRow.matchSetClosed, tournamentSettlementMatchSetDataRow.matchSetRemainScore)),
                                                    onKeyup: _withKeys(($event: any) => (_ctx.updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult(tournamentSettlementMatchSetDataRow.matchIndexNumber, tournamentSettlementMatchSetDataRow.matchSet, tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam, true, tournamentSettlementMatchSetDataRow.matchSetDart, tournamentSettlementMatchSetDataRow.matchSetClosed, tournamentSettlementMatchSetDataRow.matchSetRemainScore)), ["enter"]),
                                                    error: (tournamentSettlementMatchSetDataRow.matchSetDirtyFlag & 2) === 2,
                                                    "error-messages": "Værdien er ugyldigt",
                                                    label: "",
                                                    placeholder: "#",
                                                    disabled: (tournamentMatchSettlementDataRow.matchGuestTeamPlayer === undefined || tournamentMatchSettlementDataRow.matchGuestTeamPlayer === null || tournamentMatchSettlementDataRow.matchGuestTeamPlayer === 'Z' || (tournamentMatchSettlementDataRow.matchIsDouble && (tournamentMatchSettlementDataRow.matchGuestTeamPlayer2 === undefined || tournamentMatchSettlementDataRow.matchGuestTeamPlayer2 === null || tournamentMatchSettlementDataRow.matchGuestTeamPlayer2 === 'Z')) || (!tournamentMatchSettlementDataRow.matchIsDouble && (tournamentMatchSettlementDataRow.matchHomeTeamPlayer === undefined || tournamentMatchSettlementDataRow.matchHomeTeamPlayer === null || tournamentMatchSettlementDataRow.matchHomeTeamPlayer === '9'))),
                                                    bordered: ""
                                                  }, {
                                                    appendInner: _withCtx(() => [
                                                      ((tournamentSettlementMatchSetDataRow.matchSetDirtyFlag & 4) === 4)
                                                        ? (_openBlock(), _createBlock(_component_va_icon, {
                                                            key: 0,
                                                            name: "loop",
                                                            spin: "counter-clockwise",
                                                            class: "mr-2"
                                                          }))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "onKeyup", "error", "disabled"])
                                                ], 8, _hoisted_385))
                                              : _createCommentVNode("", true),
                                            (tournamentSettlementMatchSetDataRow.matchIndexNumber === (tournamentMatchSettlementDataRow.matchRealIndexNumber + 1) && tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam === false)
                                              ? (_openBlock(), _createElementBlock("td", {
                                                  key: 1,
                                                  id: 'tournamentmatchsettlementsettable-row-lt' + (index2 + 1)
                                                }, [
                                                  _createVNode(_component_va_input, {
                                                    class: "mb-4",
                                                    type: "number",
                                                    modelValue: tournamentSettlementMatchSetDataRow.matchSetDart,
                                                    "onUpdate:modelValue": ($event: any) => ((tournamentSettlementMatchSetDataRow.matchSetDart) = $event),
                                                    onChange: ($event: any) => (_ctx.updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult(tournamentSettlementMatchSetDataRow.matchIndexNumber, tournamentSettlementMatchSetDataRow.matchSet, tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam, true, tournamentSettlementMatchSetDataRow.matchSetDart, tournamentSettlementMatchSetDataRow.matchSetClosed, tournamentSettlementMatchSetDataRow.matchSetRemainScore)),
                                                    onKeyup: _withKeys(($event: any) => (_ctx.updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult(tournamentSettlementMatchSetDataRow.matchIndexNumber, tournamentSettlementMatchSetDataRow.matchSet, tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam, true, tournamentSettlementMatchSetDataRow.matchSetDart, tournamentSettlementMatchSetDataRow.matchSetClosed, tournamentSettlementMatchSetDataRow.matchSetRemainScore)), ["enter"]),
                                                    error: (tournamentSettlementMatchSetDataRow.matchSetDirtyFlag & 1) === 1,
                                                    "error-messages": "Værdien er ugyldigt",
                                                    label: "",
                                                    placeholder: "#",
                                                    disabled: (tournamentMatchSettlementDataRow.matchGuestTeamPlayer === undefined || tournamentMatchSettlementDataRow.matchGuestTeamPlayer === null || tournamentMatchSettlementDataRow.matchGuestTeamPlayer === 'Z' || (tournamentMatchSettlementDataRow.matchIsDouble && (tournamentMatchSettlementDataRow.matchGuestTeamPlayer2 === undefined || tournamentMatchSettlementDataRow.matchGuestTeamPlayer2 === null || tournamentMatchSettlementDataRow.matchGuestTeamPlayer2 === 'Z')) || (!tournamentMatchSettlementDataRow.matchIsDouble && (tournamentMatchSettlementDataRow.matchHomeTeamPlayer === undefined || tournamentMatchSettlementDataRow.matchHomeTeamPlayer === null || tournamentMatchSettlementDataRow.matchHomeTeamPlayer === '9'))),
                                                    bordered: ""
                                                  }, {
                                                    appendInner: _withCtx(() => [
                                                      ((tournamentSettlementMatchSetDataRow.matchSetDirtyFlag & 4) === 4)
                                                        ? (_openBlock(), _createBlock(_component_va_icon, {
                                                            key: 0,
                                                            name: "loop",
                                                            spin: "counter-clockwise",
                                                            class: "mr-2"
                                                          }))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "onKeyup", "error", "disabled"])
                                                ], 8, _hoisted_386))
                                              : _createCommentVNode("", true),
                                            (tournamentSettlementMatchSetDataRow.matchIndexNumber === (tournamentMatchSettlementDataRow.matchRealIndexNumber + 1) && tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam === false)
                                              ? (_openBlock(), _createElementBlock("td", {
                                                  key: 2,
                                                  id: 'tournamentmatchsettlementsettable-row-lt' + (index2 + 1)
                                                }, [
                                                  _createVNode(_component_va_input, {
                                                    class: "mb-4",
                                                    type: "number",
                                                    modelValue: tournamentSettlementMatchSetDataRow.matchSetRemainScore,
                                                    "onUpdate:modelValue": ($event: any) => ((tournamentSettlementMatchSetDataRow.matchSetRemainScore) = $event),
                                                    onChange: ($event: any) => (_ctx.updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult(tournamentSettlementMatchSetDataRow.matchIndexNumber, tournamentSettlementMatchSetDataRow.matchSet, tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam, true, tournamentSettlementMatchSetDataRow.matchSetDart, tournamentSettlementMatchSetDataRow.matchSetClosed, tournamentSettlementMatchSetDataRow.matchSetRemainScore)),
                                                    onKeyup: _withKeys(($event: any) => (_ctx.updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult(tournamentSettlementMatchSetDataRow.matchIndexNumber, tournamentSettlementMatchSetDataRow.matchSet, tournamentSettlementMatchSetDataRow.matchHomeOrGuestTeam, true, tournamentSettlementMatchSetDataRow.matchSetDart, tournamentSettlementMatchSetDataRow.matchSetClosed, tournamentSettlementMatchSetDataRow.matchSetRemainScore)), ["enter"]),
                                                    error: (tournamentSettlementMatchSetDataRow.matchSetDirtyFlag & 8) === 8,
                                                    "error-messages": "Værdien er ugyldigt",
                                                    label: "",
                                                    placeholder: "#",
                                                    disabled: (tournamentMatchSettlementDataRow.matchGuestTeamPlayer === undefined || tournamentMatchSettlementDataRow.matchGuestTeamPlayer === null || tournamentMatchSettlementDataRow.matchGuestTeamPlayer === 'Z' || (tournamentMatchSettlementDataRow.matchIsDouble && (tournamentMatchSettlementDataRow.matchGuestTeamPlayer2 === undefined || tournamentMatchSettlementDataRow.matchGuestTeamPlayer2 === null || tournamentMatchSettlementDataRow.matchGuestTeamPlayer2 === 'Z')) || (!tournamentMatchSettlementDataRow.matchIsDouble && (tournamentMatchSettlementDataRow.matchHomeTeamPlayer === undefined || tournamentMatchSettlementDataRow.matchHomeTeamPlayer === null || tournamentMatchSettlementDataRow.matchHomeTeamPlayer === '9'))),
                                                    bordered: ""
                                                  }, {
                                                    appendInner: _withCtx(() => [
                                                      ((tournamentSettlementMatchSetDataRow.matchSetDirtyFlag & 4) === 4)
                                                        ? (_openBlock(), _createBlock(_component_va_icon, {
                                                            key: 0,
                                                            name: "loop",
                                                            spin: "counter-clockwise",
                                                            class: "mr-2"
                                                          }))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "onKeyup", "error", "disabled"])
                                                ], 8, _hoisted_387))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ])
                                ], 8, _hoisted_381)),
                            (tournamentMatchSettlementDataRow.matchGuestTeamPlayer === undefined || tournamentMatchSettlementDataRow.matchGuestTeamPlayer === null || tournamentMatchSettlementDataRow.matchGuestTeamPlayer2 === undefined || tournamentMatchSettlementDataRow.matchGuestTeamPlayer2 === null)
                              ? (_openBlock(), _createElementBlock("td", {
                                  key: 6,
                                  id: 'tournamentmatchsettlementtable-row' + (index + 1)
                                }, "-", 8, _hoisted_388))
                              : (_openBlock(), _createElementBlock("td", {
                                  key: 7,
                                  id: 'tournamentmatchsettlementtable-row' + (index + 1)
                                }, [
                                  _createTextVNode(_toDisplayString((tournamentMatchSettlementDataRow.matchGuestTeamPlayer === 'Z' ? '' : tournamentMatchSettlementDataRow.matchGuestTeamPlayer + ' ' + tournamentMatchSettlementDataRow.matchGuestTeamPlayerName)), 1),
                                  _hoisted_390,
                                  _createTextVNode(_toDisplayString((tournamentMatchSettlementDataRow.matchGuestTeamPlayer2 === 'Z' ? '' : tournamentMatchSettlementDataRow.matchGuestTeamPlayer2 + ' ' + tournamentMatchSettlementDataRow.matchGuestTeamPlayer2Name)), 1),
                                  _hoisted_391,
                                  _createTextVNode(_toDisplayString((tournamentMatchSettlementDataRow.matchGuestScoreResultRecorder === null ? '' : (tournamentMatchSettlementDataRow.matchGuestScoreResultRecorder === '0' ? '* Udlæg & tavlefører' : '* (' + tournamentMatchSettlementDataRow.matchGuestScoreResultRecorder + ')'))), 1)
                                ], 8, _hoisted_389))
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editTournamentMatchSettlementTeamProtestStatusModal,
          "onUpdate:modelValue": _cache[215] || (_cache[215] = ($event: any) => ((_ctx.editTournamentMatchSettlementTeamProtestStatusModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[213] || (_cache[213] = ($event: any) => (_ctx.updateTournamentMatchSettlementTeamProtestStatus() ? _ctx.$Message.success({ text: 'Ændringen af status blev gemt' }) : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' })))
            }, {
              default: _withCtx(() => [
                _hoisted_399
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[214] || (_cache[214] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), _ctx.cancelTournamentMatchSettlementTeamProtestStatusEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_400
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_395, [
              _hoisted_396,
              _createElementVNode("div", _hoisted_397, [
                _createElementVNode("div", _hoisted_398, [
                  _createVNode(_component_va_option_list, {
                    type: "radio",
                    options: ['Ingen', 'Protest fra hjemmeholdet', 'Protest fra udeholdet'],
                    modelValue: _ctx.tournamentMatchSettlementTeamProtestStatusValue,
                    "onUpdate:modelValue": _cache[212] || (_cache[212] = ($event: any) => ((_ctx.tournamentMatchSettlementTeamProtestStatusValue) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editTournamentMatchSettlementTeamPlayersModal,
          "onUpdate:modelValue": _cache[220] || (_cache[220] = ($event: any) => ((_ctx.editTournamentMatchSettlementTeamPlayersModal) = $event)),
          size: "large",
          "overlay-opacity": "0.5",
          "hide-default-actions": "",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[218] || (_cache[218] = ($event: any) => (_ctx.updateMatchSettlementTeamPlayersEdit() ? _ctx.$Message.success({ text: 'Ændringerne af holdspiller-oplysningerne blev gemt' }) : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' + (_ctx.checkPlayerRestrictionsFlag > 0 ? ' ' + _ctx.getMatchSettlementTeamPlayerCheckFlagMsg() : '' ) })))
            }, {
              default: _withCtx(() => [
                _hoisted_412
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[219] || (_cache[219] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), (_ctx.editTournamentMatchSettlementTeamPlayersModal = false), _ctx.cancelUpdateMatchSettlementTeamPlayersEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_413
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_401, "Tilføj eller fjern holdspillere for kampafviklingen " + _toDisplayString(_ctx.tournamentMatchScheduleData.matchNumber), 1),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_402, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_403, [
              _createElementVNode("div", _hoisted_404, [
                _createElementVNode("div", _hoisted_405, [
                  (_ctx.matchSettlementHomeTeamPlayersNameOptions !== undefined)
                    ? (_openBlock(), _createBlock(_component_va_select, {
                        key: 0,
                        label: "Vælg hjemmeholdets spillere",
                        modelValue: _ctx.matchSettlementHomeTeamPlayersNameValue,
                        "onUpdate:modelValue": _cache[216] || (_cache[216] = ($event: any) => ((_ctx.matchSettlementHomeTeamPlayersNameValue) = $event)),
                        options: _ctx.matchSettlementHomeTeamPlayersNameOptions,
                        "text-by": "name",
                        searchable: "",
                        multiple: "",
                        "max-selections": _ctx.matchSettlementNumberOfTeamPlayersMaxSelections,
                        bordered: ""
                      }, null, 8, ["modelValue", "options", "max-selections"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_406, [
                  (_ctx.matchSettlementGuestTeamPlayersNameOptions !== undefined)
                    ? (_openBlock(), _createBlock(_component_va_select, {
                        key: 0,
                        label: "Vælg udeholdets spillere",
                        modelValue: _ctx.matchSettlementGuestTeamPlayersNameValue,
                        "onUpdate:modelValue": _cache[217] || (_cache[217] = ($event: any) => ((_ctx.matchSettlementGuestTeamPlayersNameValue) = $event)),
                        options: _ctx.matchSettlementGuestTeamPlayersNameOptions,
                        "text-by": "name",
                        searchable: "",
                        multiple: "",
                        "max-selections": _ctx.matchSettlementNumberOfTeamPlayersMaxSelections,
                        bordered: ""
                      }, null, 8, ["modelValue", "options", "max-selections"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_407, [
                _createElementVNode("div", _hoisted_408, [
                  (_ctx.matchSettlementHomeTeamPlayersNameValue !== undefined && _ctx.matchSettlementHomeTeamPlayersNameValue.length > 0)
                    ? (_openBlock(), _createBlock(_component_va_list, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_list_label, null, {
                            default: _withCtx(() => [
                              _hoisted_409
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matchSettlementHomeTeamPlayersNameValue, (matchSettlementHomeTeamPlayerNameValue, playerindex) => {
                            return (_openBlock(), _createBlock(_component_va_list_item, { key: playerindex }, {
                              default: _withCtx(() => [
                                _createVNode(_component_va_list_item_section, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_va_list_item_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString((playerindex + 1).toString() + '. ' + matchSettlementHomeTeamPlayerNameValue.name.slice(0, (matchSettlementHomeTeamPlayerNameValue.name.indexOf('],') >= 0 ? matchSettlementHomeTeamPlayerNameValue.name.indexOf('],') + 1 : matchSettlementHomeTeamPlayerNameValue.name.length))), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_va_list_item_label, { caption: "" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString('Køn: ' + (Number(matchSettlementHomeTeamPlayerNameValue.gender) === 1 ? 'Dame' : (Number(matchSettlementHomeTeamPlayerNameValue.gender) === 2 ? 'Herre' : '?'))), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_va_divider)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_410, [
                  (_ctx.matchSettlementGuestTeamPlayersNameValue !== undefined && _ctx.matchSettlementGuestTeamPlayersNameValue.length > 0)
                    ? (_openBlock(), _createBlock(_component_va_list, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_list_label, null, {
                            default: _withCtx(() => [
                              _hoisted_411
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matchSettlementGuestTeamPlayersNameValue, (matchSettlementGuestTeamPlayerNameValue, playerindex) => {
                            return (_openBlock(), _createBlock(_component_va_list_item, { key: playerindex }, {
                              default: _withCtx(() => [
                                _createVNode(_component_va_list_item_section, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_va_list_item_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(String.fromCharCode(playerindex + 65).toString() + '. ' + matchSettlementGuestTeamPlayerNameValue.name.slice(0,  (matchSettlementGuestTeamPlayerNameValue.name.indexOf('],') >= 0 ? matchSettlementGuestTeamPlayerNameValue.name.indexOf('],') + 1 : matchSettlementGuestTeamPlayerNameValue.name.length))), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_va_list_item_label, { caption: "" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString('Køn: ' + (Number(matchSettlementGuestTeamPlayerNameValue.gender) === 1 ? 'Dame' : (Number(matchSettlementGuestTeamPlayerNameValue.gender) === 2 ? 'Herre' : '?'))), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_va_divider)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Turneringsplan']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_414, [
        _createElementVNode("div", _hoisted_415, [
          _createElementVNode("div", _hoisted_416, [
            _createVNode(_component_va_button, {
              class: "btn",
              rounded: false,
              onClick: _cache[221] || (_cache[221] = ($event: any) => (_ctx.teamSort()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, {
                  class: "reset",
                  name: "autorenew"
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_417, [
            _createVNode(_component_va_select, {
              label: "Sæson",
              modelValue: _ctx.teamSeasonFilterValue,
              "onUpdate:modelValue": _cache[222] || (_cache[222] = ($event: any) => ((_ctx.teamSeasonFilterValue) = $event)),
              options: _ctx.teamSeasonFilterOptions,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_418, [
            _createVNode(_component_va_select, {
              label: "Turneringskategori",
              modelValue: _ctx.tournamentCategoryFilterValue,
              "onUpdate:modelValue": _cache[223] || (_cache[223] = ($event: any) => ((_ctx.tournamentCategoryFilterValue) = $event)),
              options: _ctx.tournamentCategoryFilterOptions,
              border: ""
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_419, [
            _createVNode(_component_va_select, {
              label: "Klub",
              modelValue: _ctx.teamFilterValue,
              "onUpdate:modelValue": _cache[224] || (_cache[224] = ($event: any) => ((_ctx.teamFilterValue) = $event)),
              options: _ctx.teamFilterOptions,
              searchable: "",
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_420, [
            _createVNode(_component_va_select, {
              label: "Række",
              modelValue: _ctx.tournamentRowFilterValue,
              "onUpdate:modelValue": _cache[225] || (_cache[225] = ($event: any) => ((_ctx.tournamentRowFilterValue) = $event)),
              options: _ctx.tournamentRowFilterOptions,
              bordered: "",
              searchable: ""
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_421, [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_va_button, {
                  key: 0,
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_VaInnerLoading, {
                      bg: "primary",
                      color: "white",
                      loading: ""
                    }),
                    _hoisted_422
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_va_button, {
                  key: 1,
                  onClick: _cache[226] || (_cache[226] = ($event: any) => (_ctx.exportDataToExcel())),
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_423
                  ]),
                  _: 1
                }))
          ])
        ]),
        _createVNode(_component_it_divider),
        _createElementVNode("div", _hoisted_424, [
          _createElementVNode("table", _hoisted_425, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _hoisted_426,
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[227] || (_cache[227] = ($event: any) => (_ctx.teamSort('teamName')))
                }, "Holdnavn"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[228] || (_cache[228] = ($event: any) => (_ctx.teamSort('clubName')))
                }, "Klubnavn"),
                _hoisted_427,
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[229] || (_cache[229] = ($event: any) => (_ctx.teamSort('row')))
                }, "Række"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[230] || (_cache[230] = ($event: any) => (_ctx.teamSort('afbud')))
                }, "Afbud"),
                _hoisted_428
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: team.id
                }, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_va_icon, {
                      name: team.hold_status ? 'check_circle' : 'highlight_off',
                      color: team.hold_status ? 'success' : 'danger'
                    }, null, 8, ["name", "color"])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(team.hold_holdnavn), 1),
                  _createElementVNode("td", null, _toDisplayString(team?.klubber_id?.klubber_klubnavn), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.getCategoryNameFromId(team?.raekke_id?.turneringskategori_id)), 1),
                  _createElementVNode("td", null, _toDisplayString(team?.raekke_id?.raekke_navn), 1),
                  _createElementVNode("td", {
                    textContent: _toDisplayString(_ctx.totalCancelTeamArr[team.id])
                  }, null, 8, _hoisted_429),
                  _createElementVNode("td", null, [
                    _createVNode(_component_va_button, {
                      color: "info",
                      gradient: "",
                      onClick: ($event: any) => (_ctx.editTeamInfo(Number(team.id)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_430
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_431, [
          _createVNode(_component_va_button, {
            icon: "first_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[231] || (_cache[231] = ($event: any) => (_ctx.jumpToTeamPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[232] || (_cache[232] = ($event: any) => (_ctx.turnToNewTeamPage(-5)))
          }),
          _createVNode(_component_va_button, {
            icon: "chevron_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[233] || (_cache[233] = ($event: any) => (_ctx.turnToNewTeamPage(-1)))
          }),
          _hoisted_432,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[234] || (_cache[234] = ($event: any) => ((_ctx.currentTeamPage) = $event)),
            type: "number",
            onKeyup: _cache[235] || (_cache[235] = _withKeys(($event: any) => (_ctx.jumpToPage(this.currentTeamPage)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.currentTeamPage]
          ]),
          (_ctx.totalNumberOfTeamPages === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_433, " af " + _toDisplayString(_ctx.totalNumberOfTeamPages+1), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_434, " af " + _toDisplayString(_ctx.totalNumberOfTeamPages), 1)),
          _createVNode(_component_va_button, {
            icon: "chevron_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[236] || (_cache[236] = ($event: any) => (_ctx.turnToNewTeamPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[237] || (_cache[237] = ($event: any) => (_ctx.turnToNewTeamPage(5)))
          }),
          _createVNode(_component_va_button, {
            icon: "last_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[238] || (_cache[238] = ($event: any) => (_ctx.jumpToTeamPage(this.totalNumberOfTeamPages)))
          }),
          _hoisted_435,
          _createElementVNode("div", _hoisted_436, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.teamPageSizeValueString,
              "onUpdate:modelValue": _cache[239] || (_cache[239] = ($event: any) => ((_ctx.teamPageSizeValueString) = $event)),
              options: _ctx.teamPageSizeOptions,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.teamWithdrawWarningModal,
          "onUpdate:modelValue": _cache[242] || (_cache[242] = ($event: any) => ((_ctx.teamWithdrawWarningModal) = $event)),
          "overlay-opacity": "0.5",
          "hide-default-actions": ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_438, [
              _createElementVNode("div", _hoisted_439, [
                _createVNode(_component_va_button, {
                  class: "mr-2",
                  color: "secondary",
                  onClick: _cache[240] || (_cache[240] = ($event: any) => (_ctx.teamWithdrawWarningModal = !_ctx.teamWithdrawWarningModal))
                }, {
                  default: _withCtx(() => [
                    _hoisted_440
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_button, {
                  class: "ml-2",
                  color: "danger",
                  onClick: _cache[241] || (_cache[241] = ($event: any) => (_ctx.withDrawTeam()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_441
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_437
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.teamDataModal,
          "onUpdate:modelValue": _cache[245] || (_cache[245] = ($event: any) => ((_ctx.teamDataModal) = $event)),
          size: "large",
          "overlay-opacity": "0.5",
          "hide-default-actions": ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_464, [
              _createElementVNode("div", _hoisted_465, [
                _createVNode(_component_va_button, {
                  color: "secondary",
                  onClick: _cache[244] || (_cache[244] = ($event: any) => (_ctx.teamDataModal = !_ctx.teamDataModal))
                }, {
                  default: _withCtx(() => [
                    _hoisted_466
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_442, _toDisplayString('Information om ' + _ctx.teamData.hold_holdnavn), 1),
            _createVNode(_component_va_card, {
              color: "#afcfff",
              gradient: "",
              stripe: "",
              "stripe-color": "#2f5f4f"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_443, [
                  _createElementVNode("div", _hoisted_444, [
                    _createElementVNode("div", _hoisted_445, [
                      _createElementVNode("p", _hoisted_446, "Række: " + _toDisplayString(_ctx.teamData.raekke_id.raekke_navn), 1)
                    ]),
                    _createElementVNode("div", _hoisted_447, [
                      _createElementVNode("p", _hoisted_448, "Klub: " + _toDisplayString(_ctx.teamData.klubber_id.klubber_klubnavn), 1)
                    ]),
                    _createElementVNode("div", _hoisted_449, [
                      _createElementVNode("p", _hoisted_450, "Status: " + _toDisplayString(_ctx.teamData.hold_status ? 'Aktiv' : 'Trukket'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_451, [
                      _createElementVNode("p", _hoisted_452, "Antal afbud: " + _toDisplayString(_ctx.numberCancellations), 1)
                    ]),
                    _createElementVNode("div", _hoisted_453, [
                      _createElementVNode("p", _hoisted_454, "Antal udeblivelser: " + _toDisplayString(_ctx.numberNonAppearance), 1)
                    ]),
                    _createElementVNode("div", _hoisted_455, [
                      _createVNode(_component_va_button, {
                        color: "danger",
                        gradient: "",
                        onClick: _cache[243] || (_cache[243] = ($event: any) => (_ctx.withDrawWarning(Number(_ctx.teamData.id))))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_456
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            (_ctx.teamMatchSchedule.length > 0)
              ? (_openBlock(), _createBlock(_component_va_card, {
                  key: 0,
                  color: "#afcfff",
                  gradient: "",
                  stripe: "",
                  "stripe-color": "#2f5f4f",
                  class: "teamMatchSchedule"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_457, [
                      _createElementVNode("table", _hoisted_458, [
                        _hoisted_459,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamMatchSchedule, (item) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: item.id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(item.kampprogram_kampnr), 1),
                              (item.kampprogram_nydato === null)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_460, _toDisplayString(_ctx.toDanishDateStringWClock(_ctx.locConvertFromUTCtoLocalDateTime(item.kampprogram_dato))), 1))
                                : (_openBlock(), _createElementBlock("td", _hoisted_461, [
                                    _createElementVNode("span", _hoisted_462, _toDisplayString(_ctx.toDanishDateStringWClock(_ctx.locConvertFromUTCtoLocalDateTime(item.kampprogram_dato))), 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.toDanishDateStringWClock(_ctx.locConvertFromUTCtoLocalDateTime(item.kampprogram_nydato))), 1)
                                  ])),
                              _createElementVNode("td", null, _toDisplayString(item.kampprogram_hjemmehold.hold_holdnavn), 1),
                              _createElementVNode("td", null, _toDisplayString(item.kampprogram_udehold.hold_holdnavn), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getTeamResults(item.id)), 1),
                              (item.kampgodkendt_id !== null)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_463, [
                                    _createVNode(_component_va_icon, {
                                      name: item.kampgodkent_id !== null && item.kampgodkendt_id.kampgodkendt_godkendt ? 'check' : '',
                                      color: item.kampgodkent_id !== null && item.kampgodkendt_id.kampgodkendt_godkendt ? 'success' : ''
                                    }, null, 8, ["name", "color"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Hold oversigt']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_467, [
        _createElementVNode("div", _hoisted_468, [
          _createElementVNode("div", _hoisted_469, [
            _createVNode(_component_va_select, {
              class: "ml-4",
              modelValue: _ctx.filterPlayerValidationHistoryValue,
              "onUpdate:modelValue": _cache[246] || (_cache[246] = ($event: any) => ((_ctx.filterPlayerValidationHistoryValue) = $event)),
              options: _ctx.filterPlayerVaidationHistoryOptions,
              bordered: "",
              style: {"width":"75%"},
              label: "Team"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_470, [
            _createVNode(_component_va_select, {
              class: "ml-4",
              modelValue: _ctx.filterPlayerValidationHistoryBasedOnStatus,
              "onUpdate:modelValue": _cache[247] || (_cache[247] = ($event: any) => ((_ctx.filterPlayerValidationHistoryBasedOnStatus) = $event)),
              options: _ctx.filterPlayerVaidationHistoryStatusOptions,
              bordered: "",
              style: {"width":"75%"},
              label: "Status"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_471, [
            _createVNode(_component_va_button, { onClick: _ctx.setOrderOfPlayerHistory }, {
              default: _withCtx(() => [
                _hoisted_472,
                (!_ctx.isSortingAscending)
                  ? (_openBlock(), _createBlock(_component_va_icon, {
                      key: 0,
                      name: "arrow_drop_down"
                    }))
                  : (_openBlock(), _createBlock(_component_va_icon, {
                      key: 1,
                      name: "arrow_drop_up"
                    }))
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_473, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_474, [
              _createElementVNode("table", _hoisted_475, [
                _hoisted_476,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPlayersHistoriesData, (player) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "playerRow",
                      key: player.id,
                      onClick: ($event: any) => (_ctx.setSelectedPlayer(player)),
                      style: {"cursor":"pointer"}
                    }, [
                      _createElementVNode("td", null, _toDisplayString(player?.matchId.kampprogram_kampnr), 1),
                      _createElementVNode("td", null, _toDisplayString(player.playerName), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.errorMessages[player.info]), 1),
                      _createElementVNode("td", null, _toDisplayString(player.teamId?.hold_holdnavn), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.toDanishDateStringWClock(_ctx.locConvertFromUTCtoLocalDateTime(player.created_at))), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_va_button, {
                          color: (player?.status === null || player?.status === 'Waiting') ? 'info' : player.status === 'Open' ? 'rgb(64, 229, 131)' : 'danger',
                          onClick: ($event: any) => (_ctx.confirmToUpdateSatatus($event, player)),
                          disabled: player?.status === 'Closed'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString((player?.status === null || player?.status === 'Waiting') ? 'Waiting' : player.status === 'Open' ? 'Open' : 'Closed'), 1)
                          ]),
                          _: 2
                        }, 1032, ["color", "onClick", "disabled"])
                      ])
                    ], 8, _hoisted_477))
                  }), 128))
                ])
              ])
            ])),
        _createElementVNode("div", _hoisted_478, [
          _createVNode(_component_va_button, {
            icon: "first_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[248] || (_cache[248] = ($event: any) => (_ctx.jumpToPageOfHistory(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[249] || (_cache[249] = ($event: any) => (_ctx.turnToNewHistoryPage(-5)))
          }),
          _createVNode(_component_va_button, {
            icon: "chevron_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[250] || (_cache[250] = ($event: any) => (_ctx.turnToNewHistoryPage(-1)))
          }),
          _hoisted_479,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[251] || (_cache[251] = ($event: any) => ((_ctx.currentHistoryPage) = $event)),
            onKeyup: _cache[252] || (_cache[252] = _withKeys(($event: any) => (_ctx.jumpToPageOfHistory(this.currentHistoryPage)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.currentHistoryPage]
          ]),
          (_ctx.totalNumberOfHistoryPages === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_480, " af " + _toDisplayString(_ctx.totalNumberOfHistoryPages+1), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_481, " af " + _toDisplayString(_ctx.totalNumberOfHistoryPages), 1)),
          _createVNode(_component_va_button, {
            icon: "chevron_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[253] || (_cache[253] = ($event: any) => (_ctx.turnToNewHistoryPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[254] || (_cache[254] = ($event: any) => (_ctx.turnToNewHistoryPage(5)))
          }),
          _createVNode(_component_va_button, {
            icon: "last_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[255] || (_cache[255] = ($event: any) => (_ctx.jumpToPageOfHistory(this.totalNumberOfHistoryPages)))
          }),
          _hoisted_482,
          _createElementVNode("div", _hoisted_483, [
            _createVNode(_component_va_select, {
              class: "mr-2",
              modelValue: _ctx.historyPageSizeValueString,
              "onUpdate:modelValue": _cache[256] || (_cache[256] = ($event: any) => ((_ctx.historyPageSizeValueString) = $event)),
              options: _ctx.historyPageSizeOption,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Player History']
      ])
    ]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.lastPlayedMatchModel,
      "onUpdate:modelValue": _cache[260] || (_cache[260] = ($event: any) => ((_ctx.lastPlayedMatchModel) = $event)),
      "closable-mask": false,
      "close-on-esc": false
    }, {
      header: _withCtx(() => [
        _createElementVNode("h6", _hoisted_484, _toDisplayString(_ctx.selectedPlayersLastMatchData?.playerName), 1),
        _createElementVNode("h6", _hoisted_485, _toDisplayString(_ctx.selectedPlayersLastMatchData?.teamId.hold_holdnavn), 1),
        _createElementVNode("h6", _hoisted_486, _toDisplayString(_ctx.selectedPlayersMatchRaekke?.raekke_navn), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_487, [
          _hoisted_488,
          (_ctx.lastPlayedMatch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_489, [
                _hoisted_490,
                _createElementVNode("div", _hoisted_491, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.lastPlayedMatch?.kampprogram_kampnr), 1)
                ]),
                _hoisted_492,
                _createElementVNode("div", _hoisted_493, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.lastPlayedMatch?.kampprogram_dato && _ctx.toDanishDateStringWClock(_ctx.locConvertFromUTCtoLocalDateTime(_ctx.lastPlayedMatch.kampprogram_dato))), 1)
                ]),
                _hoisted_494,
                _createElementVNode("div", _hoisted_495, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.lastPlayedMatch?.raekke_id.raekke_navn), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_496, _hoisted_498)),
          _hoisted_499,
          (_ctx.nextPlannedMatch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_500, [
                _hoisted_501,
                _createElementVNode("div", _hoisted_502, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.nextPlannedMatch?.kampprogram_kampnr), 1)
                ]),
                _hoisted_503,
                _createElementVNode("div", _hoisted_504, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.nextPlannedMatch?.kampprogram_dato && _ctx.toDanishDateStringWClock(_ctx.locConvertFromUTCtoLocalDateTime(_ctx.nextPlannedMatch?.kampprogram_dato))), 1)
                ]),
                _hoisted_505,
                _createElementVNode("div", _hoisted_506, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.nextPlannedMatch?.raekke_id.raekke_navn), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_507, _hoisted_509)),
          _hoisted_510,
          (_ctx.selectedPlayersLastMatchData?.comment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_511, [
                _createElementVNode("p", _hoisted_512, _toDisplayString(_ctx.selectedPlayersLastMatchData?.comment), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_513, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.playerHistoryComment,
              "onUpdate:modelValue": _cache[257] || (_cache[257] = ($event: any) => ((_ctx.playerHistoryComment) = $event)),
              modelModifiers: { trim: true },
              class: "mb-6",
              type: "text",
              placeholder: "Enter comment",
              style: {"width":"100%"},
              clearable: true,
              clearableIcon: "clear",
              clearValue: ""
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, {
                  name: "comment",
                  color: "secondary"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              icon: "add",
              color: "info",
              gradient: "",
              class: "mr-6",
              disabled: _ctx.playerHistoryComment === '',
              onClick: _cache[258] || (_cache[258] = ($event: any) => (_ctx.addPlayerHistoryComment()))
            }, {
              default: _withCtx(() => [
                _hoisted_514
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_515, [
          _createElementVNode("div", _hoisted_516, [
            _createElementVNode("div", _hoisted_517, [
              _createVNode(_component_va_button, {
                color: "secondary",
                onClick: _cache[259] || (_cache[259] = ($event: any) => (_ctx.lastPlayedMatchModel = false, _ctx.selectedPlayersLastMatchData = null, _ctx.nextPlannedMatch = null, _ctx.matchHistoryData = null, _ctx.lastPlayedMatch = null, _ctx.selectedPlayersMatchRaekke = null))
              }, {
                default: _withCtx(() => [
                  _hoisted_518
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.confirmationModal,
      "onUpdate:modelValue": _cache[263] || (_cache[263] = ($event: any) => ((_ctx.confirmationModal) = $event)),
      "hide-default-actions": "",
      "overlay-opacity": "0.2"
    }, {
      header: _withCtx(() => [
        _hoisted_519
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_va_button, {
          style: {"background":"rgb(64, 229, 131)"},
          onClick: _cache[261] || (_cache[261] = ($event: any) => (_ctx.updateSatatus()))
        }, {
          default: _withCtx(() => [
            _hoisted_521
          ]),
          _: 1
        }),
        _createVNode(_component_va_button, {
          color: "secondary",
          onClick: _cache[262] || (_cache[262] = ($event: any) => (_ctx.confirmationModal = false, _ctx.selectedPlayersLastMatchData = null))
        }, {
          default: _withCtx(() => [
            _hoisted_522
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _hoisted_520
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}